
import type { Language } from '../types';

const commonEn = {
    moveItem: 'Move Item',
    deleteFromList: 'Delete from list',
    searchResultsCount: 'Found {n} results',
    noItemsInSearch: 'No items found',
    createItem: 'Create New Item',
    unit_g: 'g',
    unit_kg: 'kg',
    unit_ml: 'ml',
    unit_liter: 'liter',
    unit_cup: 'cup',
    unit_tbsp: 'tbsp',
    unit_heaping_tbsp: 'heaping tbsp',
    unit_level_tsp: 'level tsp',
    unit_tsp: 'tsp',
    unit_unit: 'unit',
    unit_pinch: 'pinch',
    unit_as_needed: 'as needed',
    unit_to_taste: 'to taste',
    'unit_to taste': 'to taste',
    'unit_as needed': 'as needed',
    unit_bunch: 'bunch',
    unit_package: 'package',
    unit_basket: 'basket',
    unit_clove: 'clove',
    unit_head: 'head',
    unit_container: 'container',
    unit_tub: 'tub',
    unit_handful: 'handful',
    unit_stalk: 'stalk',
    unit_can: 'can',
    unit_bottle: 'bottle',
    unit_bag: 'bag',
    unit_box: 'box',
    unit_roll: 'roll',
    unit_days: 'days',
    unit_weeks: 'weeks',
    unit_times: 'Times',
    unit_servings: 'servings',
    unit_mins: 'mins',
    card_servings: 'P',
    card_mins: 'm',
    card_hours: 'h',
    unit_shot: 'shot',
    unit_jar: 'jar',
    unit_slice: 'slice',
    unit_slices: 'slices',
    unit_cube: 'cube',
    unit_cubes: 'cubes',
    unit_a_little: 'a little',
    unit_whole: 'whole',
    unit_half: 'half',
    unit_quarter: 'quarter',
    unit_third: 'third',
    unit_to_choose: 'to choose',
    'unit_לבחירה': 'to choose',
    'unit_מעט': 'a little',
    'unit_שלם': 'whole',
    'unit_חצי': 'half',
    'unit_רבע': 'quarter',
    'unit_שליש': 'third',
    // Hebrew Origin Units (mapped to English for compatibility)
    'unit_כוס': 'cup',
    'unit_כוסות': 'cups',
    'unit_כף': 'tbsp',
    'unit_כפות': 'tbsp',
    'unit_כף גדושה': 'heaping tbsp',
    'unit_כפות גדושות': 'heaping tbsp',
    'unit_כפית': 'tsp',
    'unit_כפיות': 'tsp',
    'unit_כפית שטוחה': 'level tsp',
    'unit_כפיות שטוחות': 'level tsp',
    'unit_גרם': 'g',
    'unit_ק"ג': 'kg',
    'unit_קג': 'kg',
    'unit_קילו': 'kg',
    'unit_קילוגרם': 'kg',
    'unit_מ"ל': 'ml',
    'unit_מל': 'ml',
    'unit_ליטר': 'liter',
    'unit_יחידה': 'unit',
    'unit_יחידות': 'units',
    'unit_חבילה': 'package',
    'unit_שקית': 'bag',
    'unit_מכל': 'container',
    'unit_קופסא': 'box',
    'unit_צנצנת': 'jar',
    'unit_פחית': 'can',
    'unit_בקבוק': 'bottle',
    'unit_צרור': 'bunch',
    'unit_ראש': 'head',
    'unit_שן': 'clove',
    'unit_שיניים': 'cloves',
    'unit_גבעול': 'stalk',
    'unit_גבעולים': 'stalks',
    'unit_קורט': 'pinch',
    'unit_לפי הטעם': 'to taste',
    'unit_לפי הצורך': 'as needed',
    'unit_גרגרים': 'grains',
    'unit_קוביות': 'cubes',
    'unit_פרוסות': 'slices',
    'unit_אינץ\'': 'inch',
    'unit_ס"מ': 'cm',
    'unit_סלסלה': 'basket',
    'unit_סלסלאות': 'baskets',
    'unit_גביע': 'tub',
    'unit_גביעים': 'tubs',
    'unit_חופן': 'handful',
    'unit_חופנים': 'handfuls',
    // Common Ingredients (Canonical IDs)
    ingredient_salt: 'Salt',
    ingredient_sugar: 'Sugar',
    ingredient_water: 'Water',
    ingredient_flour: 'Flour',
    ingredient_oil: 'Oil',
    ingredient_butter: 'Butter',
    ingredient_eggs: 'Eggs',
    'ingredient_baking powder': 'Baking Powder',
    ingredient_onion: 'Onion',
    ingredient_garlic: 'Garlic',
    // UI Labels
    butcherItem: 'Butcher',
    // Common Recipe Sections
    sauce: 'Sauce',
    dough: 'Dough',
    filling: 'Filling',
    topping: 'Topping',
    base: 'Base',
    cream: 'Cream',
    batter: 'Batter',
    'add-ins': 'Add-ins',
    addins: 'Add-ins',
    seasoning: 'Seasoning',
    spices: 'Spices',
    snacks: 'Snacks',
    babyProducts: 'Baby Products',
    babyproducts: 'Baby Products',
    produce: 'Produce',
    dry_goods: 'Dry Goods',
    liquid: 'Liquid',
    main: 'Main',
    totalLabel: 'Total',
    joinedHouseholds: 'Joined Households',
    residents: 'Residents',
    resident: 'Resident',
    dietaryRestrictions: 'Dietary & Allergies',
    tempUsers: 'Temporary Users',
    addTempUser: 'Add Temporary User',
    deleteTempUserConfirm: 'Are you sure you want to remove this temporary user access link? This will deactivate the link permanently.',
    tempUserAdded: 'Temporary user access link created!',
    residentsHeader: 'Residents',
    residentsCount: 'Residents Count',
    invite: 'Invite',
    notTenant: 'Non-Tenant',
    adultsCount: 'Adults',
    childrenCount: 'Children',
    ownerRole: 'Owner',
    adminRole: 'Admin',
    editorRole: 'Editor',
    viewerRole: 'Viewer',
    idLabel: 'ID',
    personalHouseholdName: 'Personal',
    viewAsUser: 'View as User',
    exitImpersonation: 'Back to Superuser',
    impersonatingBanner: 'Viewing as {name}',
    recipeUsage: 'Recipe Usage',
    manualAdjustment: 'Manual Adjustment',
    copyBtn: 'Copy',
    householdInfo: 'Household Info',
    status_active: 'Active',
    inventoryStatus: 'Inventory Status',
    bestFor: 'Best For',
    characteristics: 'Characteristics',
    lifestyleTags: 'Characteristics',
    isKidFriendly: 'Loved by kids',
    isQuickPrep: 'Quick prep',
    isBudgetFriendly: 'Budget friendly',
    dietaryPreferences: 'Dietary Preferences',
    ketoOnly: 'Keto Only',
    visibilityLabel: 'Visibility',
    filterAndSort: 'Filter & Sort',
    householdFit: 'Fit for household residents',
    householdFitEmpty: 'Add tenant nutrition in household settings first',
    customizeView: 'Customize View',
    clearAll: 'Clear All',
    clearSearch: 'Clear search',
    backToPlanner: 'Back to planning',
    quickRecipeCreateTitle: 'Create recipe',
    quickRecipeCreateMessage: 'A temporary recipe with only a name will be added. It stays private and can be shared only with households you manage. You can add ingredients and instructions later.',
    temporaryRecipeBadge: 'Temp',
    temporaryRecipeVisibilityHint: 'Temporary recipes stay private. You can share them only with households you manage.',
    createAndSchedule: 'Create & schedule',
    selected: 'selected',
    favorites: 'Favorites',
    favorite: 'Favorite',
    unfavorite: 'Remove favorite',
    showFavorites: 'Show favorites only',
    sortAsc: 'Ascending',
    sortDesc: 'Descending',
    chefsWithRecipes: 'Chefs credited on your recipes',
    searchChefPlaceholder: 'Search chefs...',
    gdprNotice: 'GDPR Notice: We use cookies and local storage to ensure you get the best experience on our website.',
    iUnderstand: 'I Understand',
    installAppTitle: 'Use mealPai like an app',
    installAppBody: 'Add it to your home screen for quick access to your meal plan and shopping list.',
    installAppHintIOS: 'Tap the Share button, then choose "Add to Home Screen".',
    installAppAction: 'Add to Home Screen',
    installAppLater: 'Maybe later',
    installApp: 'Install app',
    installAppMenuItem: 'Install mealPai app',
    installAppMenuDesc: 'Add mealPai to your home screen for a full-screen, app-like experience.',
    installAppInstalledLabel: 'mealPai is installed on this device',
    installAppShareHint: 'Share recipes from Instagram, Facebook, or Chrome: tap Share and choose mealPai. If mealPai does not appear, remove the home-screen icon and install again from Chrome.',
    installAppGuideTitle: 'Add mealPai to your home screen',
    installAppHintGeneric: 'Open your browser menu and choose "Install app" or "Add to Home Screen".',
    installAppIOSStep1: 'Tap the Share button in Safari\'s toolbar.',
    installAppIOSStep2: 'Scroll down and choose "Add to Home Screen".',
    installAppIOSStep3: 'Tap "Add" to finish.',
    menu: 'Menu',
    profile: 'Profile',
    activeHousehold: 'Active Household',
    dataManagement: 'Data Management',
    admin: 'Admin',
    personalDetails: 'Personal Details',
    settings: 'Settings',
    manageHouseholds: 'Manage Households',
    sharePlan: 'Share Plan',
    exportData: 'Export Data',
    importData: 'Import Data',
    restoreLegacy: 'Restore Legacy',
    manageUsers: 'Manage Users',
    approveSubs: 'Approve Subs',
    logout: 'Logout',
    about: 'About',
    contact: 'Contact',
    myProfile: 'My Profile',
    firstName: 'First Name',
    lastName: 'Last Name',
    nickname: 'Nickname',
    language: 'Language',
    save: 'Save',
    cancel: 'Cancel',
    ok: 'OK',
    addRecipe: 'Add Recipe',
    editRecipe: 'Edit Recipe',
    recipePhoto: 'Recipe photo',
    recipePhotoAdd: 'Add photo',
    recipePhotoChange: 'Change photo',
    recipePhotoTake: 'Take photo',
    recipePhotoChoose: 'Choose from device',
    recipePhotoUploading: 'Uploading photo...',
    recipePhotoUploadFailed: 'Could not upload photo. Try again.',
    recipePhotoRemove: 'Remove photo',
    recipePhotoInvalidType: 'Please choose a JPEG, PNG, WebP, or GIF image.',
    recipePhotoSourceTitle: 'Add recipe photo',
    recipePhotoFromUrl: 'From URL',
    recipePhotoFromDevice: 'From device',
    recipePhotoFromCamera: 'Camera',
    recipePhotoUrlPlaceholder: 'https://...',
    recipePhotoUrlRequired: 'Please enter an image URL.',
    recipePhotoUrlInvalid: 'Please enter a valid image URL.',
    recipePhotoGalleryAdd: 'Add another photo',
    recipePhotoGalleryView: 'View photo',
    recipePhotoGalleryImage: 'Photo',
    goToRecipe: 'Go to Recipe',
    deleteRecipe: 'Delete Recipe',
    createHousehold: 'Create Household',
    householdName: 'Household Name',
    create: 'Create',
    members: 'Members',
    addMember: 'Add Member',
    search: 'Search',
    noRecipes: 'No recipes found',
    shoppingList: 'Shopping List',
    reminders: 'Reminders',
    notifications: 'Notifications',
    notificationsEmpty: 'No notifications yet',
    markAllRead: 'Mark all read',
    shareImportStartedTitle: 'Import started',
    shareImportStartedBody: 'We are analyzing this link in the background. You can leave the app — we will notify you when the recipe is ready.\n\n{url}',
    shareImportSuccessTitle: 'Recipe saved',
    shareImportSuccessBody: '{name} was imported from your shared link.',
    shareImportFailedTitle: 'Import failed',
    shareImportFailedBody: 'Could not import the shared link.',
    shareImportDuplicateTitle: 'Recipe already exists',
    shareImportDuplicateBody: '{name} is already in your recipes.',
    shareImportNoUrl: 'No link found in the shared content.',
    shareImportNoAi: 'AI access is required to import shared links.',
    shareImportInProgress: 'An import is already in progress.',
    weeklyPlan: 'Weekly Plan',
    monthlyPlan: 'Monthly Plan',
    meat: 'Meat',
    ingredients: 'Ingredients',
    instructions: 'Instructions',
    links: 'Links',
    servings: 'Servings',
    category: 'Category',
    anonymous: 'Anonymous',
    isKeto: 'Keto',
    isVegetarian: 'Vegetarian',
    isVegan: 'Vegan',
    isGlutenFree: 'Gluten Free',
    isPaleo: 'Paleo',
    isLowCarb: 'Low Carb',
    isDairyFree: 'Dairy Free',
    dietLabels: 'Diet Labels',
    personalGeminiKey: 'Personal AI Key',
    personalGeminiKeyDesc: 'Add your own Gemini API key to enable AI features. Your key is encrypted and stored securely — never visible in plain text.',
    personalGeminiKeyPrivacy: 'Your key is tied exclusively to your account. It is never shared with other users, even if they belong to the same household.',
    viewKey: 'View',
    hide: 'Hide',
    saveKey: 'Save Key',
    updateKey: 'Update',
    removeKey: 'Remove',
    keyHidesIn30s: 'Key will hide automatically in 30 seconds',
    enableAiFeatures: 'Enable AI Features',
    geminiKeyHowToTitle: 'How to get a Gemini API key',
    geminiKeyHowToStep1Open: 'Open Google AI Studio',
    geminiKeyHowToStep2: 'Sign in with your Google account',
    geminiKeyHowToStep3: 'Go to "Get API key" and create a new key',
    geminiKeyHowToStep4: 'Copy the key and paste it below',
    linkPreferredOverText: 'Both link and text are filled. The link will be used and the text will be ignored.',
    recipeTextForAi: 'Recipe Text',
    recipeTextForAiDesc: 'Paste or edit the full recipe text for AI analysis. For existing recipes, this is pre-filled from the current recipe.',
    editRecipeText: 'Edit Recipe Text',
    recipeTextReady: 'Recipe text ready for analysis',
    isPublic: 'Public',
    shareWithHouseholds: 'Share with Households',
    aiAnalyze: 'AI Analyze',
    pasteLink: 'Paste Link',
    pasteText: 'Paste Text',
    analyze: 'Analyze',
    analyzing: 'Analyzing...',
    relearn: 'Re-learn',
    selectLanguage: 'Select Language',
    weekLast: 'Last Week',
    weekThis: 'This Week',
    weekNext: 'Next Week',
    weekly: 'Weekly',
    monthly: 'Monthly',
    importCurrentWeek: 'Import Current Week',
    returnToThisWeek: 'Return to This Week',
    returnToThisMonth: 'Return to This Month',
    morning: 'Morning',
    noon: 'Noon',
    evening: 'Evening',
    breakfast: 'Breakfast',
    lunch: 'Lunch',
    dinner: 'Dinner',
    recipes: 'Recipes',
    select: 'Select',
    add: 'Add',
    all: 'All',
    mine: 'Mine',
    shared: 'Shared',
    allCategories: 'All Categories',
    private: 'Private',
    public: 'Public',
    currentHousehold: 'Current Household',
    recipeOwner: 'Recipe Owner',
    unknownUser: 'Unknown User',
    meatShoppingList: 'Meat List',
    planMealsHint: 'Plan meat meals to see defrost reminders here',
    sources: 'Sources',
    bulkShoppingList: 'Bulk Shopping List',
    selectAll: 'Select All',
    itemsSelected: 'Items Selected',
    copyList: 'Copy List',
    close: 'Close',
    previousMonth: 'Previous month',
    nextMonth: 'Next month',
    copied: 'Copied!',
    nothingSelected: 'Nothing Selected',
    meal: 'Meal',
    first: 'First',
    side: 'Side',
    dessert: 'Dessert',
    spread: 'Spread',
    snack: 'Snack',
    general: 'General',
    notice: 'Notice',
    limitReached: 'Limit Reached',
    visibleMeals: 'Visible Meals',
    myHouseholds: 'My Households',
    primary: 'Primary',
    details: 'Details',
    mealSettings: 'Meal Settings',
    me: 'Me',
    delete: 'Delete',
    id: 'ID',
    copy: 'Copy',
    role: 'Role',
    approve: 'Approve',
    decline: 'Decline',
    dismiss: 'Dismiss',
    pending: 'Pending',
    subscribed: 'Subscribed',
    canceled: 'Canceled',
    declined: 'Declined',
    subscriptionEnds: 'Expires',
    actions: 'Actions',
    email: 'Email',
    user: 'User',
    currentStatus: 'Current Status',
    shareLinkText: 'Share Link',
    copyLink: 'Copy Link',
    loginTitle: 'Login',
    loginBtn: 'Login',
    registerBtn: 'Register',
    noAccount: "Don't have an account?",
    passwordPlaceholder: 'Password',
    emailPlaceholder: 'Email',
    existingAccount: 'Already have an account?',
    welcome: 'Welcome',
    copyFromCurrent: 'Copy from Current',
    weekStart: 'Week Start',
    startSunday: 'Sunday',
    startMonday: 'Monday',
    day_Sunday: 'Sunday',
    day_Monday: 'Monday',
    day_Tuesday: 'Tuesday',
    day_Wednesday: 'Wednesday',
    day_Thursday: 'Thursday',
    day_Friday: 'Friday',
    day_Saturday: 'Saturday',
    searchResults: 'Search Results',
    noResults: 'No results found',
    day: 'Day',
    schedule: 'Schedule',
    deleted: 'Deleted',
    scheduleInMenu: 'Schedule in Menu',
    manageHouseholdsTitle: 'Manage Households',
    createNewHousehold: 'Create New Household',
    householdNamePlaceholder: 'e.g. Home',
    visibleMealsLabel: 'Visible Meals',
    mustSelectOneMeal: 'Must select at least one meal',
    cannotDisableAllMeals: 'Cannot disable all meals',
    myHouseholdsTitle: 'My Households',
    mealSettingsTitle: 'Meal Settings',
    membersTitle: 'Members',
    removeUserConfirm: 'Are you sure you want to remove this user?',
    removeUser: 'Remove User',
    addUserPlaceholder: 'User Email',
    orderMeat: 'Order Meat',
    deleteHousehold: 'Delete Household',
    noHouseholdsToManage: 'No households to manage',
    copyId: 'Copy ID',
    householdLimitTitle: 'Household Limit Reached',
    householdLimitDesc: 'You have reached the limit of {limit} households.',
    householdEntitlement: 'Household Entitlement',
    householdEntitlementHint: 'Maximum households this user can own (default 5).',
    createGuidedClient: 'Create Guided Client',
    guidedClientCreated: 'Guided client created. Copy the access link below.',
    guidedClientLinkHint: 'Share this full link with your client. It cannot be recovered later — use Refresh link to generate a new one.',
    myGuidedClients: 'My Clients',
    guidedClientsAdmin: 'Guided Clients',
    guidedClientsAdminAllHint: 'All guided clients across consultants.',
    guidedClientsAdminMineHint: 'Your assigned guided clients.',
    guidedClientsFilterActive: 'Active',
    guidedClientsFilterInactive: 'Inactive',
    guidedClientsFilterNotifications: 'With messages',
    guidedClientsUnreadBadge: 'New message',
    backToClientList: 'Back to list',
    assignedConsultant: 'Consultant',
    searchGuidedClients: 'Search clients by name or email…',
    noGuidedClients: 'No guided clients yet.',
    selectGuidedClient: 'Select a client to manage.',
    selectConsultant: 'Select consultant…',
    knownAllergies: 'Known Allergies',
    knownAllergiesHint: 'Tap the allergens that apply.',
    allergyPeanuts: 'Peanuts',
    allergyTreeNuts: 'Tree nuts',
    allergyMilk: 'Milk',
    allergyEggs: 'Eggs',
    allergyWheat: 'Wheat',
    allergyGluten: 'Gluten',
    allergySoy: 'Soy',
    allergyFish: 'Fish',
    allergyShellfish: 'Shellfish',
    allergySesame: 'Sesame',
    allergyMustard: 'Mustard',
    allergyCelery: 'Celery',
    allergySulphites: 'Sulphites',
    allergyLupin: 'Lupin',
    allergyMolluscs: 'Molluscs',
    allergyFavaBeans: 'Broad beans',
    suitableForAllergies: 'Suitable for allergies…',
    addAllergy: 'Add allergen',
    allAllergies: 'All allergens',
    addDiet: 'Add preference',
    allDiets: 'All preferences',
    dietFilterPickerTitle: 'Choose dietary preferences',
    allergyFilterPickerTitle: 'Hide recipes with these allergens',
    allergyFilterInfoTitle: 'Allergy filter',
    allergyFilterInfoBody: 'Select allergens to hide recipes that likely contain those ingredients. Detection is based on ingredient names and may not catch every source.',
    allergyFilterDisclaimer: 'This is a convenience filter only — not medical advice. Always re-read ingredient lists, labels, and sub-recipes before cooking or serving, especially for severe allergies.',
    nutritionPrefsManagedHere: 'Nutrition preferences can be updated here.',
    refreshAccessLink: 'Refresh Access Link',
    openClientHousehold: 'Open Client Household',
    active: 'Active',
    inactive: 'Inactive',
    deactivateClientAccess: 'Deactivate',
    guidedAccessSubtitle: 'Enter the email address your consultant registered for you.',
    guidedAccessEmailPlaceholder: 'your@email.com',
    guidedAccessEmailMismatch: 'That email does not match this invitation.',
    guidedAccessContinue: 'Continue',
    guidedAccessStandardLogin: 'Sign in with password or Google',
    guidedAccessInvalidLink: 'This access link is invalid or expired.',
    guidedAccessFailed: 'Could not sign in with this link.',
    proFeature: 'Pro',
    guidedClientContextBanner: 'Managing client:',
    guidedClientsHouseholdHint: 'Open a guided client household from Guided Clients under Admin.',
    exitClientContext: 'Exit client view',
    consultationBox: 'Ask My Consultant',
    goPro: 'Go Pro',
    goProDescription: 'Upgrade to a full account with your own recipes and households.',
    goProSetPassword: 'Set password & upgrade',
    goProLinkGoogle: 'Link Google account & upgrade',
    goProPasswordTooShort: 'Password must be at least 6 characters.',
    goProPasswordMismatch: 'Passwords do not match.',
    goProFailed: 'Upgrade failed. Try again.',
    goProNoAccessRelation: 'No consultant link found for this profile.',
    confirmPassword: 'Confirm password',
    or: 'or',
    send: 'Send',
    consultationEmpty: 'No messages yet. Ask your consultant anything about your plan.',
    certifiedDietitian: 'Certified Dietitian',
    profileBio: 'Profile description',
    profileBioPlaceholder: 'Tell clients a little about yourself…',
    consultantCertification: 'Certification',
    consultantCertificationPlaceholder: 'e.g. Certified Dietitian',
    avatarUrl: 'Avatar image URL',
    avatarUrlPlaceholder: 'https://…',
    coverPhotoUrl: 'Cover image URL',
    coverPhotoUrlPlaceholder: 'https://…',
    tapAvatarToEdit: 'Tap your avatar to update the image link',
    tapCoverToEdit: 'Tap the cover image to update the link',
    planUpdated: 'Plan updated',
    phraseOfTheDayAdmin: 'Phrase of the Day',
    phraseOfTheDayHint: 'Visible to all guided households for {days} days after publishing.',
    phraseOfTheDayCurrent: 'Current phrase',
    phraseOfTheDayPlaceholder: 'Write a short motivational message for your clients…',
    phraseOfTheDaySet: 'Publish phrase',
    phraseOfTheDayPublishNew: 'Publish as new',
    phraseOfTheDayHistory: 'History',
    phraseOfTheDayHistoryEmpty: 'No previous phrases yet.',
    phraseOfTheDayExpires: 'Expires',
    timeJustNow: 'Just now',
    timeMinuteAgo: '1 minute ago',
    timeMinutesAgo: '{n} minutes ago',
    timeHourAgo: '1 hour ago',
    timeHoursAgo: '{n} hours ago',
    timeDayAgo: '1 day ago',
    timeDaysAgo: '{n} days ago',
    consultationPlaceholder: 'Type your question…',
    consultationReplyPlaceholder: 'Reply to client…',
    duplicateForHousehold: 'Copy for this household',
    personalDetailsWarning: 'Please fill in your personal details',
    termsOfService: 'Terms of Service',
    text: 'Text',
    link: 'Link',
    nameLabel: 'Name',
    sourceLanguageLabel: 'Source Language',
    weeklyCarts: 'Weekly Carts',
    shoppingCarts: 'Shopping Carts',
    addCart: 'Add Cart',
    editCart: 'Edit Cart',
    deleteCart: 'Delete Cart',
    weeksMultiplier: 'Weeks Multiplier',
    combineCarts: 'Combine Carts',
    viewRecipes: 'View Recipes',
    viewChefRecipes: 'View {count} recipes',
    viewRecipe: 'View Recipe',
    viewIngredients: 'View Ingredients',
    viewCarts: 'View Carts',
    cartLabel: 'Cart Name',
    noPlanToCopy: 'No previous plan to copy',
    aiLoadingMsg: 'Working on it...',
    saveLoadingMsg: 'Saving...',
    aiStep_reading: 'Reading recipe',
    aiStep_analyzing: 'Analyzing',
    aiStep_ingredients: 'Processing ingredients',
    aiStep_prepSteps: 'Building prep steps',
    aiStep_nutrition: 'Analyzing nutrition',
    aiStep_allergensDiet: 'Analyzing allergens & diet fit',
    aiStep_saving: 'Saving',
    recipeSavePending: 'Preparing recipe…',
    recipeSavePendingHint: 'You can leave — we will finish in the background',
    activeCart: 'Active Cart',
    remaining: 'Remaining',
    itemMoved: 'Item moved',
    undo: 'Undo',
    done: 'Done',
    addToActive: 'Add to Active',
    inActiveCart: 'In cart',
    addItem: 'Add Item',
    miscItems: 'Misc Items',
    moveToCart: 'Move to Cart',
    newCart: 'New Cart',
    unit: 'Unit',
    quantity: 'Quantity',
    searchOrAdd: 'Search or Add',
    revert: 'Revert',
    markDone: 'Mark Done',
    markUndone: 'Mark Undone',
    markComplete: 'Mark step complete',
    markIncomplete: 'Mark step incomplete',
    markRecipeDone: 'Mark recipe as done',
    recipeDone: 'Recipe complete',
    recipeReadyBadge: 'Ready',
    recipeInProgressBadge: 'In preparation',
    mealDonePromptTitle: 'All recipes are ready!',
    mealDonePromptMessage: 'Every prep step is complete. Mark this meal as done?',
    markMealDone: 'Mark meal as done',
    mealCompletedTitle: 'Meal complete',
    mealCompletedMessage: 'Great work — this meal is done.',
    viewMenu: 'View menu',
    deleteSelected: 'Delete Selected',
    clearCompleted: 'Clear Completed',
    shareList: 'Share List',
    emptyCart: 'Empty Cart',
    cartIsEmpty: 'Your cart is empty',
    emptyCartConfirm: 'Are you sure you want to empty the cart?',
    clearCompletedConfirm: 'Are you sure you want to delete completed items?',
    hideDone: 'Hide Done',
    showDone: 'Show Done',
    allCollected: 'All collected',
    today: 'Today',
    tomorrow: 'Tomorrow',
    defrost: 'Defrost',
    defrostForMeal: 'Defrost for {meal} · {day}',
    buy: 'Buy',
    reminder: 'Reminder',
    veggieDay: 'Veggie Day',
    getStarted: 'Get Started',
    appWarmingUp: 'Warming up the fire...',
    fastingTimer: 'Fasting Timer',
    fastingStart: 'Start Fast',
    fastingStop: 'Stop',
    fastingStatistics: 'Fasting Stats',
    fastingNoHistory: 'No fasting history yet.',
    fastingHoursShort: 'h ',
    fastingMinutesShort: 'm',
    fastingSecondsShort: 's',
    fastingGoalHours: 'Goal: {hours} Hours',
    fastingHoursGoal: '{hours} Hours',
    tapToManage: 'Tap to manage',
    fastingEndsAt: 'Ends at {time}',
    fastingEndsAtTomorrow: 'Ends at {time} tomorrow',
    fastingTimeRemaining: 'Time Remaining',
    fastingStartFasting: 'Start Fasting',
    fastingStartNow: 'Start Now',
    fastingChangeGoal: 'Change Goal',
    fastingEndFast: 'End Fast',
    fastingEditGoal: 'Edit Goal',
    fastingGoalReached: 'Goal Reached!',
    fastingSaveFast: 'Save Fast',
    fastingRemainingLeft: '{time} left',
    fastingCountdownRemaining: '{time} remaining',
    fastingOpenModal: 'Open fasting timer',
    fastingIdleHint: 'Tap start when you begin your eating window break.',
    intermittentFastingSetting: 'Intermittent Fasting',
    intermittentFastingSettingDesc: 'Show the fasting timer in the header. End-of-fast notifications work when the app is installed.',
    allowHouseholdInvitationsSetting: 'Allow household invitations',
    allowHouseholdInvitationsSettingDesc: 'Allow other users to invite you to join their household. If disabled, you cannot be found by email.',
    householdInvitationMsg: 'You have been invited to join the household "{name}".',
    approveInvitation: 'Approve',
    rejectInvitation: 'Reject',
    membersHeader: 'Members',
    invitedHeader: 'Invited',
    rejectedHeader: 'Rejected',
    tenantsHeader: 'Additional Tenants',
    addTenant: 'Add Tenant',
    editTenant: 'Edit Tenant',
    tenantName: 'Tenant Name',
    birthday: 'Birthday',
    nutritionProfile: 'Nutrition Profile',
    noTenants: 'No tenants added yet',
    isChildLabel: 'Child?',
    isTenantLabel: 'Is Tenant?',
    childBadge: 'Child',
    adultBadge: 'Adult',
    allergiesTitle: 'Allergies',
    showDetails: 'Show diet/allergies',
    hideDetails: 'Hide diet/allergies',
    noPreferences: 'No restrictions',
    userNotFound: 'User not found',
    userAlreadyMember: 'User is already a member of this household',
    userAlreadyInvited: 'User is already invited',
    invitationSent: 'Invitation sent successfully!',
    errorSendingInvitation: 'Error sending invitation',
    fastingNotificationTitle: 'Fast complete!',
    fastingNotificationBody: 'Your {hours}-hour fast is done. You can eat now.',
    fastingStartNotificationTitle: 'Time to fast!',
    fastingStartNotificationBody: 'Your {hours}-hour fast is starting now.',
    fastingScheduleLater: 'Schedule for later',
    fastingSetStartTime: 'Set start time',
    fastingSchedule: 'Schedule Fast',
    fastingScheduledTitle: 'Scheduled Fast',
    fastingTarget: 'Target',
    fastingTargetHours: 'Target: {hours} hours',
    fastingCancelSchedule: 'Cancel Schedule',
    fastingStartsAt: 'Starts at {time}',
    fastingStartsAtTomorrow: 'Starts tomorrow at {time}',
    fastingStartsIn: 'Starts in {time}',
    fastingEditStartTime: 'Edit Start Time',
    fastingStartTime: 'Start Time',
    fastingSaveStartTime: 'Save Start Time',
    fastingGoalDialHint: 'Drag the dial or tap a preset',
    fastingWeeklyChart: 'Last 14 days',
    fastingClearSelection: 'Clear selection',
    fastingAddEntry: 'Add entry',
    fastingAddEntryTitle: 'Add fasting entry',
    confirmDeleteFastingSessionTitle: 'Delete Fasting Session',
    confirmDeleteFastingSession: 'Are you sure you want to delete this session?',
    fastingEditStartLabel: 'Start Time',
    fastingEditEndLabel: 'End Time',
    fastingActive: 'Active',
    tutorial_step1: 'Recipes & Search',
    tutorial_step2: 'Planner & Cart Sync',
    tutorial_step3: 'Shopping Carts',
    tutorial_step4: 'Real-Time Sync',
    tutorial_step5: 'Preferences & Fasting',
    tutorial_step6: 'Household & Sharing',
    tutorial_plan_step1_title: 'Weekly / Monthly Switch',
    tutorial_plan_step1_desc: 'Easily toggle between a detailed weekly menu and a macro-level monthly view.',
    tutorial_plan_step2_title: 'Habits & Stats',
    tutorial_plan_step2_desc: 'Track your household meat consumption and plan balanced meals over time.',
    tutorial_plan_step3_title: 'Sync Shopping Cart',
    tutorial_plan_step3_desc: 'Instantly compile all ingredients required for your planned meals into your active shopping list.',
    tutorial_plan_step4_title: 'Date Navigation',
    tutorial_plan_step4_desc: 'Jump forward or backward to plan your menus ahead or view past history.',
    tutorial_plan_step5_title: 'Smart Compass',
    tutorial_plan_step5_desc: 'Get lost? Instantly snap back to the current week or month with a single click.',
    tutorial_plan_step6_title: 'Plan a Meal',
    tutorial_plan_step6_desc: 'Click the plus (+) button on any meal type row to choose or search for recipes to schedule.',
    tutorial_plan_step7_title: 'Start Cooking Session',
    tutorial_plan_step7_desc: 'Click the cooking pot icon to start a guided cooking session for all meals scheduled for that time.',
    tutorial_recipe_step1_title: 'AI Smart Import',
    tutorial_recipe_step1_desc: 'Instantly turn any recipe into your private collection! Paste a webpage link or simply share an Instagram/Facebook post to MealPai, and our AI will automatically extract the ingredients and instructions for you.',
    tutorial_recipe_step2_title: 'Search & Filtering',
    tutorial_recipe_step2_desc: 'Find exactly what you want using powerful search and smart filters (like preparation time or dietary tags).',
    tutorial_recipe_step3_title: 'Bulk Actions',
    tutorial_recipe_step3_desc: 'Select multiple recipes to schedule them in your planner or add their ingredients to your shopping cart all at once!',
    tutorial_recipe_step4_title: 'Favorites & Customization',
    tutorial_recipe_step4_desc: 'Mark recipes as favorites for quick access, edit them to fit your taste, or share them with your household.',
    tutorial_desc1: 'Search, discover, and add recipes manually or instantly via AI. Explore recipe features including cooking sessions, ingredients prep, and step-by-step instructions.',
    tutorial_desc2: 'Plan your meals by the week or month. Adding recipes to your planner automatically calculates required ingredients and synchronizes them directly to your shopping cart.',
    tutorial_desc3: 'Manage multiple shopping carts. View items grouped by category, check off what you have, edit lists, and keep track of your grocery runs.',
    tutorial_desc4: 'Your active shopping cart is synchronized in real-time. Changes made by other members of your household are updated instantly, ensuring everyone is on the same page.',
    tutorial_desc5: 'Customize your profile with preferred nutrition settings and dietary guidelines. Track your intermittent fasting sessions with manual start and end controls to build healthy habits.',
    tutorial_desc6: 'Manage your household, invite other members, and customize sharing. Switch between personal and family accounts to sync plans and lists.',
    tutorial_tip1: 'Recipe Features & AI Import',
    tutorial_tip2: 'Weekly & Monthly Meals',
    tutorial_tip3: 'Category Grouping',
    tutorial_tip4: 'Active Cart Sync',
    tutorial_tip5: 'Nutrition & Fasting Preferences',
    tutorial_tip6: 'Household Settings',
    tutorial_tip_public: 'Share with Community',
    previous: 'Previous',
    nextStep: 'Next',
    gotIt: 'Got it',
    skip: 'Skip',
    recipeAlreadyScheduledTitle: 'Recipe Already Scheduled',
    recipeAlreadyScheduledMsg: 'is already scheduled for',
    tutorial_step: 'Step',
    viewBooklet: 'View Booklet',
    contactBody: 'Contact us for any questions or support.',
    sendEmailBtn: 'Send Email',
    addNewSection: 'Add New Section',
    orWithEmail: 'Or with email',
    agreeToTerms: 'I agree to the Terms of Service',
    loginHeader: 'Login to your account',
    registerHeader: 'Create a new account',
    googleLogin: 'Login with Google',
    migrationConfirm: 'Confirm Migration',
    migrateLegacyRecipeOwnership: 'Assign Legacy Recipe Owners',
    migrateLegacyRecipeOwnershipDone: 'Legacy recipe ownership updated for {n} recipes.',
    migrateLegacyRecipeOwnershipNone: 'No legacy recipes need ownership assignment in the target household.',
    migrateLegacyRecipeOwnershipConfirm: 'Assign ownership for recipes',
    migrateLegacyRecipeOwnershipFailed: 'Legacy recipe ownership migration failed.',
    migrationsPanelTitle: 'Data migrations',
    migrations: 'Migrations',
    migrateChefLinks: 'Migrate chef links',
    migrateChefLinksConfirm: 'Normalize and consolidate website links for',
    migrateChefLinksDone: 'Chef links migrated for {n} chefs.',
    migrateChefLinksNone: 'All chef links are already up to date.',
    migrateChefLinksFailed: 'Chef links migration failed.',
    migrateRecipeChefFromLinks: 'Associate recipe chefs from links',
    migrateRecipeChefFromLinksConfirm: 'Associate chefs from source links for',
    migrateRecipeChefFromLinksDone: 'Chef credit applied to {n} recipes from source links.',
    migrateRecipeChefFromLinksNone: 'No recipes without chef credit match an existing chef from their links.',
    migrateRecipeChefFromLinksFailed: 'Recipe chef association migration failed.',
    migrateRecipeFilterMetadata: 'Normalize recipe filter metadata',
    migrateRecipeFilterMetadataConfirm: 'Normalize filter metadata for',
    migrateRecipeFilterMetadataDone: 'Filter metadata updated for {n} recipes.',
    migrateRecipeFilterMetadataNone: 'All recipes already have normalized filter metadata.',
    migrateRecipeFilterMetadataFailed: 'Recipe filter metadata migration failed.',
    fixSuccess: 'Fix Successful',
    overallRating: 'Overall Rating',
    agreeContinue: 'Agree & Continue',
    to: 'to',
    prep: 'Prep',
    for: 'for',
    deleteItems: 'Delete Items',
    collapse: 'Collapse',
    showAll: 'Show All',
    plan_free: 'Free',
    plan_free_for_life: 'Free for Life',
    cookMeal: 'Cook Meal',
    prepTab: 'Prep',
    prepGatherIngredients: 'Gather all your ingredients before you start',
    cookingMeal: 'Cooking {meal}',
    gatherIngredients: 'Gather Ingredients',
    printMenu: 'Print Menu',
    mealNamePlaceholder: 'Name this meal...',
    editMealName: 'Edit meal name',
    startPrep: 'Start Prep',
    prepTimelineTitle: 'Prep Timeline',
    prepTimelineStartNow: 'Start Now',
    prepTimelineTargetTime: 'Target Meal Time',
    prepTimelineReadyBy: 'Ready by',
    prepTimelineFinishBy: 'All ready by',
    prepTimelineStartBy: 'Start earliest task by',
    prepTimelineAnalyzing: 'Analyzing prep steps...',
    prepTimelineAnalyzingHint: 'AI is estimating active work and wait times from your recipes.',
    prepTimelineFallbackNotice: 'Using estimated times — AI analysis was unavailable.',
    prepTimelineFallbackInvalidKey: 'Using estimated times — your personal Gemini API key is invalid. Update it in profile settings.',
    prepTimelineFallbackRateLimited: 'Using estimated times — too many requests. Please wait a minute and try again.',
    prepTimelineChart: 'Timeline',
    prepTimelineTotal: 'total',
    prepTimelineStartAt: 'Start at',
    prepTimelineReadyAt: 'Ready at',
    prepTimelineWait: 'Wait:',
    prepTimelineActive: 'Active',
    prepTimelineActiveWork: 'Active work',
    prepTimelinePassiveWait: 'Passive wait (fridge, rest, marinate)',
    prepTimelineStartPreviousDay: 'Start preparation the day before',
    prepTimelineReadyNextDay: 'Will be ready the next day',
    prepTimelineStartCooking: 'Start Cooking',
    prepTimelineSessionActive: 'Cooking session active',
    prepTimelineStartedAt: 'Started at {time}',
    prepTimelineStartTimeLabel: 'Start time',
    prepTimelineResetStartTime: 'Reset start time',
    prepTimelineAdjustStartTime: 'Adjust start time',
    prepTimelineAdjustStartTitle: 'Adjust start time',
    prepTimelineAdjustStartMessage: 'Reset the clock to now, or set when you actually started preparing.',
    prepTimelineResetToNow: 'Reset to now',
    prepTimelineSetActualStartTime: 'Set actual start time',
    prepTimelineSetStartTime: 'Set start time',
    prepTimelineTargetAssumedStarted: 'Prep assumed started at {time} to meet target',
    prepTimelineStopSession: 'Stop session',
    prepTimelineStopSessionConfirmTitle: 'Stop cooking session?',
    prepTimelineStopSessionConfirmMessage: 'The timeline will return to planning mode.',
    prepTimelineApplyStartTime: 'Apply',
    prepTimelineHeatDefrost: 'Heat / defrost',
    prepTimelineIncludeInChart: 'Include in timeline',
    prepTimelineOvernight: 'Overnight',
    prepTimelineStartLater: 'Start later',
    prepTimelineFinishEarly: 'Ready earlier',
    instructionStepDuration: 'Duration (minutes)',
    instructionStepDurationOptional: 'Optional — used in prep timeline',
    backToMenu: 'Back to Menu',
    creditsAndSources: 'Credits & Sources',
    addSource: 'Add Source',
    creditOriginNote: 'Credit / Origin Note',
    pasteUrlPlaceholder: 'Paste URL...',
    originNotePlaceholder: 'e.g. Grandma\'s recipe',
    newSection: 'New Section',
    prepSectionPlaceholder: 'Section Name',
    addStepTo: 'Add Step to {section}',
    describeStepPlaceholder: 'Describe step...',
    moveUp: 'Move step up',
    moveDown: 'Move step down',
    unsavedRecipeChangesTitle: 'Unsaved changes',
    unsavedRecipeChangesMessage: 'You made changes to this recipe. Save now or leave without saving?',
    saveNow: 'Save now',
    discardChanges: 'Leave without saving',
    keepEditing: 'Keep editing',
    viewFullWeek: 'View Full Week',
    monthLast: 'Last Month',
    monthNext: 'Next Month',
    monthCurrent: 'This Month',
    vegetables: 'Vegetables',
    others: 'Others',
    manual: 'Manual',
    sourcing_buy: 'Buy',
    sourcing_pantry: 'Pantry',
    sourcing_prepared: 'Prepared',
    skip_shopping_list_hint: 'Will not be added to shopping list',
    deleteMealConfirm: 'Delete this meal?',
    systemUserManagement: 'User Management',
    totalUsers: 'Total Users',
    searchUsers: 'Search Users',
    allRoles: 'All Roles',
    sortByDateAdded: 'Date Added',
    sortByName: 'Name',
    superusers: 'Superusers',
    admins: 'Admins',
    users: 'Users',
    fixPlanMetadata: 'Fix Plan Metadata',
    fixUserMetadata: 'Fix User Metadata',
    usageStatistics: 'Usage Statistics',
    systemRole: 'System Role',
    userType: 'User Type',
    userTypeRegular: 'Regular User',
    userTypeNutritionConsultant: 'Nutrition Consultant',
    allUserTypes: 'All User Types',
    subscription: 'Subscription',
    initialize: 'Initialize',
    cancelPlan: 'Cancel Plan',
    activate: 'Activate',
    confirmCancelPlan: 'Cancel subscription for {email}?',
    confirmCancelPlanHint: 'The user will lose access when their current period ends.',
    approveNewSubscriptions: 'Approve New Subscriptions',
    approveSubscription: 'Approve Subscription',
    approveSubscriptionHint: 'Choose free for life, or set an expiration date.',
    noPendingSubscriptions: 'No pending subscription requests.',
    subscriptionEndDateRequired: 'Please select an expiration date.',
    joined: 'Joined',
    ends: 'Ends',
    recipesOwned: 'Recipes Owned',
    householdsOwned: 'Households Owned',
    otherMemberships: 'Other Memberships',
    statistics: 'Statistics',
    userRecipes: 'User Recipes',
    userHouseholds: 'User Households',
    unnamedItem: 'Unnamed Item',
    noItemsFound: 'No items found',
    backToSummary: 'Back to Summary',
    userDetails: 'User Details',
    userId: 'User ID',
    termsAccepted: 'Terms Accepted',
    yes: 'Yes',
    no: 'No',
    idCopied: 'ID Copied',
    suggestionBox: 'Suggestion Box',
    addSuggestion: 'Add Suggestion',
    mySuggestions: 'My Suggestions',
    manageSuggestions: 'Manage Suggestions',
    chef: 'Chef',
    chefs: 'Chefs',
    chefCredit: 'Chef Credit',
    selectChef: 'Select chef...',
    filterByChef: 'Filter by chef',
    addChef: 'Add chef',
    requestChefRecognition: 'Request Chef Recognition',
    requestNewChef: 'Request New Chef',
    linkExistingChef: 'Link to Existing Chef',
    verifiedChef: 'Verified Chef',
    viewChefCard: 'View chef card',
    editChefProfile: 'Edit chef profile',
    manageChefs: 'Manage Chefs',
    chefProfile: 'Chef Profile',
    chefWebsite: 'Website',
    chefLinks: 'Links',
    chefLinkPlaceholder: 'https:// or @instagram',
    chefLinksHint: 'Website, Instagram profile, YouTube, etc.',
    chefAutoCredited: 'Chef {name} was added automatically from Instagram.',
    removeLink: 'Remove link',
    analyzeFailed: 'Failed to analyze recipe. Please try again.',
    recipeNotRecipeMsg: 'This text does not look like a recipe. Please paste cooking instructions with ingredients and steps.',
    recipeInappropriateMsg: 'This content cannot be analyzed. Please remove offensive or inappropriate language and try again.',
    recipeContentNotRecipeTitle: 'Not a recipe',
    recipeContentNotRecipeMsg: 'This text does not look like a recipe. Paste cooking instructions with ingredients and preparation steps.',
    recipeContentMisconductTitle: 'Inappropriate content',
    recipeContentMisconductBody: 'The entered content includes inappropriate language and is not a real recipe. Please use respectful, family-friendly content.',
    recipeContentMisconductBlockingWarning: 'Repeated misuse of this application may result in your account being blocked.',
    scraperUnavailableTitle: 'Temporarily unavailable',
    scraperUnavailableMsg: 'This option is currently unavailable and will be back soon — we are working on the issue. Please try again later or paste the recipe text instead.',
    recipeAlreadyExistsTitle: 'Recipe already exists',
    recipeAlreadyExistsMsg: 'A shared recipe from this video already exists: "{name}". Open it instead of importing again.',
    recipeSharingConflictMsg: 'Another public or shared recipe already uses this source video. Open the existing recipe or keep this one private.',
    chefRequests: 'Chef Requests',
    approveChefRequest: 'Approve',
    denyChefRequest: 'Deny',
    importChefCsv: 'Import CSV',
    exportChefCsv: 'Export CSV',
    importChefCsvShort: 'Import',
    exportChefCsvShort: 'Export',
    newChefShort: 'New',
    mergeChefsShort: 'Merge',
    importChefCsvConfirm: 'Import chefs from CSV? Existing chefs will only get missing fields filled in.',
    importChefCsvDone: 'CSV import complete',
    newChef: 'New Chef',
    originLanguage: 'Origin Language',
    updated: 'updated',
    hebrew: 'Hebrew',
    english: 'English',
    originCountry: 'Region',
    region: 'Region',
    country_israel: 'Israel',
    country_united_states: 'United States',
    country_united_kingdom: 'United Kingdom',
    country_france: 'France',
    country_italy: 'Italy',
    country_spain: 'Spain',
    country_germany: 'Germany',
    country_mexico: 'Mexico',
    country_morocco: 'Morocco',
    country_turkey: 'Turkey',
    country_lebanon: 'Lebanon',
    country_greece: 'Greece',
    country_japan: 'Japan',
    country_china: 'China',
    country_india: 'India',
    country_thailand: 'Thailand',
    country_brazil: 'Brazil',
    country_argentina: 'Argentina',
    country_canada: 'Canada',
    country_australia: 'Australia',
    country_netherlands: 'Netherlands',
    country_belgium: 'Belgium',
    country_switzerland: 'Switzerland',
    country_austria: 'Austria',
    country_portugal: 'Portugal',
    country_poland: 'Poland',
    country_egypt: 'Egypt',
    country_south_korea: 'South Korea',
    country_vietnam: 'Vietnam',
    country_iran: 'Iran',
    country_syria: 'Syria',
    country_jordan: 'Jordan',
    country_palestine: 'Palestine',
    country_tunisia: 'Tunisia',
    country_ethiopia: 'Ethiopia',
    country_iraq: 'Iraq',
    country_yemen: 'Yemen',
    country_russia: 'Russia',
    country_ukraine: 'Ukraine',
    chefName: 'Name',
    chefEnglishName: 'English Name',
    chefDescription: 'Description',
    chefDescriptionPlaceholder: 'Short bio or tagline…',
    chefInstagramUsername: 'Instagram username',
    chefInstagramUsernameHint: 'Used to refresh name, description, and photo from Instagram.',
    chefInstagramUserId: 'Instagram user ID',
    chefInstagramUserIdHint: 'Numeric Instagram pk (filled automatically from posts or refresh).',
    chefInstagramUsernameRequired: 'Enter an Instagram username to refresh.',
    chefInstagramRefreshFailed: 'Could not refresh from Instagram. Try again later.',
    refreshFromInstagram: 'Refresh',
    mergeChefs: 'Merge chefs',
    mergeChefsHint: 'Keep one chef profile and merge the other into it. Recipes and links will move to the kept chef.',
    mergeKeepChef: 'Chef to keep',
    mergeRemoveChef: 'Chef to merge & remove',
    mergeRecipesNotice: '{count} recipes will be reassigned.',
    mergePreview: 'Result preview',
    mergeConfirm: 'Merge',
    mergeSuccessSummary: '{merged} was merged into {kept}.',
    mergeRecipesUpdated: '{count} recipes updated.',
    mergeUsersUpdated: '{count} linked users updated.',
    mergeFavoritesUpdated: '{count} favorite lists updated.',
    searchChefsPlaceholder: 'Search by name or nickname…',
    chefRequestNameRequired: 'Please provide a name',
    chefRequestPending: 'You already have a pending request',
    noPendingRequests: 'No pending requests',
    message: 'Message',
    submit: 'Submit',
    errorSaving: 'Error saving',
    edit: 'Edit',
    editChef: 'Edit Chef',
    disableChef: 'Disable chef',
    disableChefHint: 'Hidden from recipe credits and selection lists',
    chefImageUrl: 'Image URL',
    skipped: 'skipped',
    total: 'total',
    linked: 'linked',
    disabled: 'Disabled',
    chefNicknameLocked: 'This chef is linked to a verified account',
    nicknameReserved: 'This nickname is reserved for a verified chef',
    subject: 'Subject',
    area: 'Area',
    status: 'Status',
    reporter: 'Reporter',
    archive: 'Archive',
    new: 'New',
    fulfilled: 'Fulfilled',
    denied: 'Denied',
    approved: 'Approved',
    allStatuses: 'All Statuses',
    shopping: 'Shopping',
    planner: 'Planner',
    household: 'Household',
    other: 'Other',
    whatAreWeCooking: 'What are we cooking?',
    chefAssistantSubtitle: 'Paste a link or text to import recipe',
    chefAssistantPlaceholder: 'Paste link or text here...',
    pasteFromClipboard: 'Paste from Clipboard',
    addLink: 'Add Link',
    scanImageBeta: 'Scan Image (Beta)',
    analyzeWithAI: 'Analyze with AI',
    editManually: 'Edit Manually',
    saveToKitchen: 'Save to Kitchen',
    ingredientsList: 'Ingredients List',
    recipeName: 'Recipe Name',
    reviewingNewMeal: 'Reviewing New Meal',
    markAsMeat: 'Mark as Meat',
    connectingSousChef: 'Connecting Sous Chef...',
    proc_reading: 'Reading recipe...',
    proc_proteins: 'Analyzing proteins...',
    proc_nutrition: 'Calculating nutrition facts...',
    nutritionFacts: 'Nutrition Facts',
    nutritionPer100g: 'per 100g',
    calories: 'Calories',
    fat: 'Fat',
    caloriesFromFat: 'Calories from fat',
    sodium: 'Sodium',
    dietaryFiber: 'Dietary Fiber',
    totalSugars: 'Total Sugars',
    addedSugars: 'Added Sugars',
    protein: 'Protein',
    recalculateNutrition: 'Recalculate',
    nutritionCalculating: 'Calculating nutrition...',
    nutritionUnavailable: 'Nutrition facts unavailable',
    proc_ingredients: 'Processing ingredients...',
    proc_steps: 'Organizing steps...',
    proc_finalizing: 'Finalizing...',
    mins: 'min',
    theme: 'Theme',
    themeLight: 'Light',
    themeDark: 'Dark',
    themeSystem: 'System',
    fontSize: 'Font Size',
    fontSizeSystem: 'System',
    fontSizeCustom: 'Custom',
    fontSmall: 'Small',
    fontDefault: 'Default',
    fontLarge: 'Large',
    exportRecipe: 'Export Recipe',
    copyText: 'Copy Text',
    textCopied: 'Text Copied!',
    unite: 'Unite',
    navigation: 'Navigation',
    quantityToMake: 'Quantity to Make',
    servingsPerMeal: 'Servings per Meal',
    recipeDefaultServingsHint: 'Recipe default: {count} servings',
    totalServings: 'Total Servings',
    futureMealsNoticeTitle: 'Batch Prep Hint',
    futureMealsPlannedHint: '{recipe} is also planned for {days}. (Total: {totalServings} servings across {totalMeals} meals)',
    scaleToTotalServings: 'Scale to total ({count} servings)',
    duration_repeat: 'Duration / Repeat',
    schedule_days_hint: 'Visible for {count} days',
    schedule_weeks_hint: 'Repeats every {day} for {count} weeks',
    unknownRecipe: 'Unknown Recipe',
    lists: 'Lists',
    sort_recent: 'Recently Added',
    sort_rated: 'Top Rated',
    filterByRating: 'Rating',
    filterRatingAndUp: '{stars}+ stars',
    sort_name: 'Name (A-Z)',
    sort_prepTime: 'Prep Time',
    proc_consistency: 'Checking consistency...',
    item: 'Item',
    editMeal: 'Edit Meal',
    ketoBadge: 'KETO',
    sectionNamePlaceholder: 'Section Name',
    section: 'Section',
    list: 'List',
    moveToSection: 'Move to Section',
    organizeList: 'Organize List',
    orCreateNewSection: 'Or Create New Section',
    newSectionNamePlaceholder: 'New Section Name',
    confirmMove: 'Confirm Move',
    moveToList: 'Move to List',
    duplicate: 'Duplicate',
    ingredientDuplicateInSection: '"{name}" already exists in section "{section}".',
    confirmDeleteNamedItem: 'Delete "{name}"?',
    confirmDeleteItemCount: 'Delete {count} items?',
    confirmDeleteSection: 'Delete section "{section}" and all its ingredients?',
    confirmDeleteCart: 'Delete "{name}"?',
    selectTargetList: 'Select Target List',
    noOtherLists: 'No other lists available',
    orCreateNewList: 'Or Create New List',
    newListNamePlaceholder: 'New List Name',
    ingredientNamePlaceholder: 'Ingredient Name',
    ingredientOptions: 'Options',
    orAlternative: 'or',
    addIngredientOption: 'Add option',
    deselectAll: 'Deselect All',
    updatingList: 'Updating List...',
    usedTimes: 'Used {count} times',
    monthlyRecipeUsage: 'Monthly Recipe Usage',
    weeklyRecipeUsage: 'Weekly Recipe Usage',
    searchIngredients: 'Search ingredients...',
    syncShoppingList: 'Sync Shopping List',
    syncShoppingCompact: 'Sync Shopping',
    viewUsage: 'View Usage',
    selectWeeks: 'Select Weeks',
    sync: 'Sync',
    reset: 'Reset',
    allWeek: 'All Week',
    next3Days: 'Next 3 Days',
    collapseAll: 'Collapse All',
    expandAll: 'Expand All',
    ordinaryItemsRemovedTitle: 'Pantry staples omitted',
    ordinaryItemsRemovedMessage: 'Water, oil, salt, sugar and similar pantry staples are omitted from this planning list. Add them directly to the active cart if needed.',
    itemsLabel: 'Items',
    currentWeekBadge: 'This Week',
    selectDaysHint: 'Select days',
    noMonthlyItemsHint: 'No items in monthly plan',
    frozen: 'Frozen',
    bakery: 'Bakery',
    beverages: 'Beverages',
    sortBy: 'Sort By',
    filter: 'Filter',
    sort: 'Sort',
    fruits: 'Fruits',
    dairy: 'Dairy',
    cleaning: 'Cleaning',
    toiletries: 'Toiletries',
    canned: 'Canned Goods',
    pantry: 'Pantry',
    generalfood: 'General Food',
    generalFood: 'General Food',
    timeline: 'Timeline',
    allTime: 'All Time',
    last7Days: 'Last 7 Days',
    last30Days: 'Last 30 Days',
    totalRequests: '{count} Total Requests',
    showingItems: 'Showing {count} items',
    submittedOn: 'Submitted On',
    changeCategory: 'Change Category',
    builtInCategories: 'Built-in Categories',
    yourShoppingLists: 'Your Shopping Lists',
    integrations: 'Integrations',
    mcpServer: 'MCP Server',
    mcpDescription: 'Connect Gemini or other AI models via Model Context Protocol',
    mcpStatus: 'Status',
    mcpUrl: 'SSE URL',
    mcpCopyUrl: 'Copy Connection URL',
    mcpConnected: 'Connected',
    mcpDisconnected: 'Disconnected',
    toolsApi: 'Tools API (REST)',
    toolsApiDescription: 'HTTP endpoints with the same recipe tools as MCP — lower cost for light use',
    toolsApiBaseUrl: 'Base URL',
    toolsApiCopyUrl: 'Copy Base URL',
    toolsApiAuthNote: 'Send your API key as Authorization: Bearer <key>',
    apiKey: 'API Key',
    generateKey: 'Generate New Key',
    aiEligible: 'AI Eligible',
    aiStatus: 'AI Status',
    aiEnabled: 'AI Enabled',
    aiDisabled: 'AI Disabled',
    aiNotEligible: 'This account is not eligible for AI features',
};

const translations: Record<Language, Partial<Record<string, string>>> = {
    en: commonEn,
    he: {
        ...commonEn,
        ingredientNamePlaceholder: 'שם המרכיב',
        ingredientOptions: 'אפשרויות',
        orAlternative: 'או',
        addIngredientOption: 'הוסף חלופה',
        changeCategory: 'שנה קטגוריה',
        builtInCategories: 'קטגוריות מובנות',
        yourShoppingLists: 'רשימות הקניות שלך',
        ingredient_salt: 'מלח',
        ingredient_sugar: 'סוכר',
        ingredient_water: 'מים',
        ingredient_flour: 'קמח',
        ingredient_oil: 'שמן',
        ingredient_butter: 'חמאה',
        ingredient_eggs: 'ביצים',
        'ingredient_baking powder': 'אבקת אפייה',
        ingredient_onion: 'בצל',
        ingredient_garlic: 'שום',
        filter: 'סינון',
        sort: 'מיון',
        moveItem: 'העבר פריט',
        deleteFromList: 'מחק מהרשימה',
        searchResultsCount: 'נמצאו {n} תוצאות',
        noItemsInSearch: 'לא נמצאו פריטים שתואמים את החיפוש',
        createItem: 'צור פריט חדש',
        'unit_גרם': 'גרם',
        'unit_ק"ג': 'ק"ג',
        'unit_קג': 'ק"ג',
        'unit_קילו': 'ק"ג',
        'unit_קילוגרם': 'ק"ג',
        'unit_מ"ל': 'מ"ל',
        'unit_מל': 'מ"ל',
        'unit_ליטר': 'ליטר',
        'unit_כוס': 'כוס',
        'unit_כוסות': 'כוסות',
        'unit_כפות': 'כפות',
        'unit_כפיות': 'כפיות',
        'unit_כף': 'כף',
        'unit_כפית': 'כפית',
        'unit_כפית שטוחה': 'כפית שטוחה',
        'unit_כפיות שטוחות': 'כפיות שטוחות',
        'unit_יחידה': 'יחידה',
        'unit_יחידות': 'יחידות',
        'unit_קורט': 'קורט',
        'unit_חבילה': 'חבילה',
        'unit_שקית': 'שקית',
        'unit_מכל': 'מכל',
        'unit_צרור': 'צרור',
        'unit_ראש': 'ראש',
        'unit_שן': 'שן',
        'unit_שיניים': 'שיניים',
        'unit_לפי הטעם': 'לפי הטעם',
        'unit_לפי הצורך': 'לפי הצורך',
        unit_a_little: 'מעט',
        unit_whole: 'שלם',
        unit_half: 'חצי',
        unit_quarter: 'רבע',
        unit_third: 'שליש',
        unit_to_choose: 'לבחירה',
        'unit_לבחירה': 'לבחירה',
        'unit_מעט': 'מעט',
        'unit_שלם': 'שלם',
        'unit_חצי': 'חצי',
        'unit_רבע': 'רבע',
        'unit_שליש': 'שליש',
        proc_nutrition: 'מחשב ערכים תזונתיים...',
        nutritionFacts: 'ערכים תזונתיים',
        nutritionPer100g: 'ל-100 גרם',
        calories: 'קלוריות',
        fat: 'שומן',
        caloriesFromFat: 'קלוריות משומן',
        sodium: 'נתרן',
        dietaryFiber: 'סיבים תזונתיים',
        totalSugars: 'סוכרים כולל',
        addedSugars: 'סוכרים מוספים',
        protein: 'חלבון',
        recalculateNutrition: 'חשב מחדש',
        nutritionCalculating: 'מחשב ערכים תזונתיים...',
        nutritionUnavailable: 'ערכים תזונתיים לא זמינים',
        'unit_גבעול': 'גבעול',
        'unit_גבעולים': 'גבעולים',
        'unit_גרגרים': 'גרגרים',
        'unit_קוביות': 'קוביות',
        'unit_פרוסות': 'פרוסות',
        'unit_צנצנת': 'צנצנת',
        'unit_פחית': 'פחית',
        'unit_קופסא': 'קופסא',
        'unit_בקבוק': 'בקבוק',
        'unit_שוט': 'שוט',
        'unit_גביע': 'גביע',
        'unit_גביעים': 'גביעים',
        'unit_חופן': 'חופן',
        'unit_חופנים': 'חופנים',
        unit_g: 'גרם',
        unit_kg: 'ק"ג',
        unit_ml: 'מ"ל',
        unit_liter: 'ליטר',
        unit_cup: 'כוס',
        unit_tbsp: 'כף',
        unit_heaping_tbsp: 'כף גדושה',
        unit_level_tsp: 'כפית שטוחה',
        unit_tsp: 'כפית',
        unit_unit: 'יחידה',
        unit_pinch: 'קורט',
        unit_as_needed: 'לפי הצורך',
        unit_to_taste: 'לפי הטעם',
        'unit_to taste': 'לפי הטעם',
        'unit_as needed': 'לפי הצורך',
        unit_bunch: 'צרור',
        unit_package: 'חבילה',
        unit_basket: 'סלסלה',
        unit_clove: 'שן',
        unit_head: 'ראש',
        unit_container: 'מיכל',
        unit_tub: 'גביע',
        unit_handful: 'חופן',
        unit_stalk: 'גבעול',
        unit_can: 'פחית',
        unit_bottle: 'בקבוק',
        unit_bag: 'שקית',
        unit_box: 'קופסא',
        unit_roll: 'גליל',
        unit_days: 'ימים',
        unit_weeks: 'שבועות',
        unit_times: 'פעמים',
        unit_servings: 'מנות',
        unit_mins: 'דק\'',
        card_servings: 'מ\'',
        card_mins: 'דק\'',
        card_hours: 'שע\'',
        unit_shot: 'שוט',
        unit_jar: 'צנצנת',
        unit_slice: 'פרוסה',
        unit_slices: 'פרוסות',
        unit_cube: 'קוביה',
        unit_cubes: 'קוביות',
        'unit_סלסלה': 'סלסלה',
        'unit_סלסלאות': 'סלסלאות',
        butcherItem: 'קצבייה',
        sauce: 'רוטב',
        dough: 'בצק',
        filling: 'מלית',
        topping: 'ציפוי',
        base: 'בסיס',
        cream: 'קרם',
        batter: 'בלילה',
        'add-ins': 'תוספות',
        addins: 'תוספות',
        seasoning: 'תיבול',
        spices: 'תבלינים',
        snacks: 'חטיפים',
        babyProducts: 'לתינוק',
        babyproducts: 'לתינוק',
        produce: 'ירקות ופירות',
        dry_goods: 'מוצרים יבשים',
        liquid: 'נוזלים',
        main: 'עיקרית',
        totalLabel: 'סה"כ',
        joinedHouseholds: 'בתים מחוברים',
        residents: 'דיירים',
        resident: 'דייר',
        dietaryRestrictions: 'תזונה ואלרגיות',
        tempUsers: 'משתמשים זמניים',
        addTempUser: 'הוסף משתמש זמני',
        deleteTempUserConfirm: 'האם אתה בטוח שברצונך להסיר קישור גישה זה של משתמש זמני? פעולה זו תבטל את הקישור לצמיתות.',
        tempUserAdded: 'נוצר קישור גישה למשתמש זמני!',
        residentsHeader: 'דיירים',
        residentsCount: 'מספר דיירים',
        invite: 'הזמן',
        notTenant: 'לא דייר',
        adultsCount: 'מבוגרים',
        childrenCount: 'ילדים',
        ownerRole: 'בעלים',
        adminRole: 'מנהל',
        editorRole: 'עורך',
        viewerRole: 'צופה',
        idLabel: 'מזהה',
        personalHouseholdName: 'אישי',
        viewAsUser: 'צפה כמשתמש',
        exitImpersonation: 'חזרה למנהל על',
        impersonatingBanner: 'צופה כ-{name}',
        recipeUsage: 'שימוש במתכונים',
        manualAdjustment: 'עדכון ידני',
        copyBtn: 'העתק',
        householdInfo: 'פרטי הבית',
        status_active: 'פעיל',
        inventoryStatus: 'סטטוס מלאי',
        bestFor: 'מתאים ל-',
        characteristics: 'מאפיינים',
        lifestyleTags: 'מאפיינים',
        isKidFriendly: 'אהוב על ילדים',
        isQuickPrep: 'הכנה מהירה',
        isBudgetFriendly: 'חסכוני',
        dietaryPreferences: 'העדפות תזונה',
        ketoOnly: 'קיטו בלבד',
        visibilityLabel: 'נראות',
        filterAndSort: 'סינון ומיון',
        householdFit: 'התאמה לדיירי הבית',
        householdFitEmpty: 'הוסיפו תזונה לדיירים בהגדרות הבית',
        customizeView: 'התאמת תצוגה',
        clearAll: 'נקה הכל',
        clearSearch: 'נקה חיפוש',
        backToPlanner: 'חזרה לתכנון',
        quickRecipeCreateTitle: 'יצירת מתכון',
        quickRecipeCreateMessage: 'יווצר מתכון זמני עם שם בלבד. הוא נשאר פרטי ואפשר לשתף אותו רק עם בתים שאתם מנהלים. אפשר להוסיף מרכיבים והוראות בהמשך.',
        temporaryRecipeBadge: 'זמני',
        temporaryRecipeVisibilityHint: 'מתכון זמני נשאר פרטי. אפשר לשתף אותו רק עם בתים שאתם מנהלים.',
        createAndSchedule: 'צור ותזמן',
        selected: 'נבחרו',
        favorites: 'מועדפים',
        favorite: 'מועדף',
        unfavorite: 'הסר ממועדפים',
        showFavorites: 'הצג מועדפים בלבד',
        sortAsc: 'עולה',
        sortDesc: 'יורד',
        chefsWithRecipes: 'שפים עם קרדיט במתכונים',
        searchChefPlaceholder: 'חיפוש שפים...',
        gdprNotice: 'הודעת GDPR: אנו משתמשים בעוגיות ובאחסון מקומי כדי להבטיח שתקבל את החוויה הטובה ביותר באתר שלנו.',
        iUnderstand: 'הבנתי',
        installAppTitle: 'השתמשו ב-mealPai כמו באפליקציה',
        installAppBody: 'הוסיפו למסך הבית לגישה מהירה לתפריט ולרשימת הקניות.',
        installAppHintIOS: 'לחצו על שיתוף, ואז בחרו "הוסף למסך הבית".',
        installAppAction: 'הוספה למסך הבית',
        installAppLater: 'אולי אחר כך',
        installApp: 'התקנת האפליקציה',
        installAppMenuItem: 'התקינו את אפליקציית mealPai',
        installAppMenuDesc: 'הוסיפו את mealPai למסך הבית לחוויית אפליקציה במסך מלא.',
        installAppInstalledLabel: 'mealPai מותקנת במכשיר זה',
        installAppShareHint: 'לשיתוף מתכונים מאינסטagram, פייסבוק או Chrome: לחצו Share ובחרו mealPai. אם mealPai לא מופיעה, הסירו את האייקון מהמסך והתקינו מחדש מ-Chrome.',
        installAppGuideTitle: 'הוספת mealPai למסך הבית',
        installAppHintGeneric: 'פתחו את תפריט הדפדפן ובחרו "התקן אפליקציה" או "הוסף למסך הבית".',
        installAppIOSStep1: 'לחצו על כפתור השיתוף בסרגל הכלים של Safari.',
        installAppIOSStep2: 'גללו מטה ובחרו "הוסף למסך הבית".',
        installAppIOSStep3: 'לחצו על "הוסף" לסיום.',
        menu: 'תפריט',
        profile: 'פרופיל',
        activeHousehold: 'בית פעיל',
        dataManagement: 'ניהול נתונים',
        admin: 'מנהל מערכת',
        personalDetails: 'פרטים אישיים',
        settings: 'הגדרות',
        manageHouseholds: 'ניהול בתים',
        sharePlan: 'שתף תכנית',
        exportData: 'ייצוא נתונים',
        importData: 'ייבוא נתונים',
        restoreLegacy: 'שחזור היסטוריה',
        manageUsers: 'ניהול משתמשים',
        approveSubs: 'אישור מנויים',
        logout: 'התנתק',
        about: 'אודות',
        contact: 'צור קשר',
        myProfile: 'הפרופיל שלי',
        firstName: 'שם פרטי',
        lastName: 'שם משפחה',
        nickname: 'כינוי',
        language: 'שפה',
        save: 'שמור',
        cancel: 'ביטול',
        ok: 'אישור',
        addRecipe: 'הוסף מתכון',
        editRecipe: 'עריכת מתכון',
        recipePhoto: 'תמונת מתכון',
        recipePhotoAdd: 'הוספת תמונה',
        recipePhotoChange: 'החלפת תמונה',
        recipePhotoTake: 'צילום',
        recipePhotoChoose: 'בחירה מהמכשיר',
        recipePhotoUploading: 'מעלה תמונה...',
        recipePhotoUploadFailed: 'לא ניתן להעלות את התמונה. נסו שוב.',
        recipePhotoRemove: 'הסרת תמונה',
        recipePhotoInvalidType: 'יש לבחור קובץ JPEG, PNG, WebP או GIF.',
        recipePhotoSourceTitle: 'הוספת תמונת מתכון',
        recipePhotoFromUrl: 'מכתובת URL',
        recipePhotoFromDevice: 'מהמכשיר',
        recipePhotoFromCamera: 'מצלמה',
        recipePhotoUrlPlaceholder: 'https://...',
        recipePhotoUrlRequired: 'יש להזין כתובת URL לתמונה.',
        recipePhotoUrlInvalid: 'יש להזין כתובת URL תקינה.',
        recipePhotoGalleryAdd: 'הוספת תמונה נוספת',
        recipePhotoGalleryView: 'צפייה בתמונה',
        recipePhotoGalleryImage: 'תמונה',
        goToRecipe: 'מעבר למתכון',
        deleteRecipe: 'מחיקת מתכון',
        createHousehold: 'צור בית חדש',
        householdName: 'שם הבית',
        create: 'צור',
        members: 'חברים',
        addMember: 'הוסף חבר',
        search: 'חיפוש',
        noRecipes: 'לא נמצאו מתכונים',
        shoppingList: 'רשימת קניות',
        reminders: 'תזכורות',
        notifications: 'התראות',
        notificationsEmpty: 'אין התראות עדיין',
        markAllRead: 'סמן הכל כנקרא',
        shareImportStartedTitle: 'הייבוא התחיל',
        shareImportStartedBody: 'אנחנו מנתחים את הקישור הזה ברקע. אפשר לצאת מהאפליקציה — נודיע לך כשהמתכון יהיה מוכן.\n\n{url}',
        shareImportSuccessTitle: 'המתכון נשמר',
        shareImportSuccessBody: '{name} יובא מהקישור ששיתפת.',
        shareImportFailedTitle: 'הייבוא נכשל',
        shareImportFailedBody: 'לא ניתן לייבא את הקישור ששיתפת.',
        shareImportDuplicateTitle: 'המתכון כבר קיים',
        shareImportDuplicateBody: '{name} כבר נמצא במתכונים שלך.',
        shareImportNoUrl: 'לא נמצא קישור בתוכן ששיתפת.',
        shareImportNoAi: 'נדרשת גישה ל-AI כדי לייבא קישורים.',
        shareImportInProgress: 'ייבוא כבר מתבצע.',
        weeklyPlan: 'תפריט',
        monthlyPlan: 'תכנון חודשי',
        meat: 'בשר',
        ingredients: 'מרכיבים',
        instructions: 'הוראות הכנה',
        links: 'קישורים',
        servings: 'מנות',
        category: 'קטגוריה',
        anonymous: 'אנונימי',
        isKeto: 'קיטו',
        isVegetarian: 'צמחוני',
        isVegan: 'טבעוני',
        isGlutenFree: 'ללא גלוטן',
        isPaleo: 'פליאו',
        isLowCarb: 'דל פחמימות',
        isDairyFree: 'ללא חלב',
        dietLabels: 'תגיות תזונה',
        personalGeminiKey: 'מפתח AI אישי',
        personalGeminiKeyDesc: 'הוסף את מפתח ה-Gemini האישי שלך כדי להפעיל יכולות AI. המפתח מוצפן ומאוחסן בצורה מאובטחת.',
        personalGeminiKeyPrivacy: 'המפתח שייך אך ורק לחשבון שלך. הוא לא משותף עם משתמשים אחרים, בשלב זה, גם אם הם חברים באותו משק בית.',
        viewKey: 'הצג',
        hide: 'הסתר',
        saveKey: 'שמור מפתח',
        updateKey: 'עדכן',
        removeKey: 'הסר',
        keyHidesIn30s: 'המפתח יוסתר אוטומטית תוך 30 שניות',
        enableAiFeatures: 'הפעלת יכולות AI',
        geminiKeyHowToTitle: 'איך להשיג מפתח Gemini API',
        geminiKeyHowToStep1Open: 'היכנסו ל-Google AI Studio',
        geminiKeyHowToStep2: 'התחברו עם חשבון Google',
        geminiKeyHowToStep3: 'עברו ל-"Get API key" וצרו מפתח חדש',
        geminiKeyHowToStep4: 'העתיקו את המפתח והדביקו אותו למטה',
        linkPreferredOverText: 'גם קישור וגם טקסט מולאו. הקישור ישמש לניתוח והטקסט יתעלם.',
        recipeTextForAi: 'טקסט מתכון',
        recipeTextForAiDesc: 'הדביקו או ערכו את טקסט המתכון המלא לניתוח AI. במתכון קיים, הטקסט מולא מראש מהמתכון הנוכחי.',
        editRecipeText: 'עריכת טקסט מתכון',
        recipeTextReady: 'טקסט המתכון מוכן לניתוח',
        isPublic: 'ציבורי',
        shareWithHouseholds: 'שתף עם בתים',
        aiAnalyze: 'ניתוח AI',
        pasteLink: 'הדבק קישור',
        pasteText: 'הדבק טקסט',
        analyze: 'נתח',
        analyzing: 'מנתח...',
        relearn: 'למד מחדש',
        selectLanguage: 'בחר שפה',
        weekLast: 'שבוע שעבר',
        weekThis: 'השבוע',
        weekNext: 'שבוע הבא',
        importCurrentWeek: 'ייבא לשבוע הנוכחי',
        weekly: 'שבועי',
        monthly: 'חודשי',
        returnToThisWeek: 'חזור לשבוע הנוכחי',
        returnToThisMonth: 'חזור לחודש הנוכחי',
        morning: 'בוקר',
        noon: 'צהריים',
        evening: 'ערב',
        breakfast: 'ארוחת בוקר',
        lunch: 'ארוחת צהריים',
          dinner: 'ארוחת ערב',
          recipes: 'מתכונים',
          select: 'בחר',
        add: 'הוסף',
        all: 'הכל',
        mine: 'שלי',
        shared: 'משותף',
        allCategories: 'כל הקטגוריות',
        private: 'פרטי',
        public: 'ציבורי',
        currentHousehold: 'בית נוכחי',
        recipeOwner: 'בעל המתכון',
        unknownUser: 'משתמש לא ידוע',
        meatShoppingList: 'רשימת בשרים',
        planMealsHint: 'תכנן ארוחות בשר כדי לראות תזכורות הפשרה',
        sources: 'מקורות',
        bulkShoppingList: 'רשימת קניות מרוכזת',
        selectAll: 'בחר הכל',
        itemsSelected: 'פריטים נבחרו',
        copyList: 'העתק רשימה',
        close: 'סגור',
        previousMonth: 'חודש קודם',
        nextMonth: 'חודש הבא',
        copied: 'הועתק!',
        nothingSelected: 'לא נבחר דבר',
        meal: 'עיקרית',
        first: 'ראשונה',
        side: 'תוספת',
        dessert: 'קינוח',
        spread: 'ממרח',
        snack: 'נשנוש',
        general: 'כללי',
        notice: 'הודעה',
        limitReached: 'הגעת למגבלה',
        visibleMeals: 'ארוחות מוצגות',
        myHouseholds: 'הבתים שלי',
        primary: 'ראשי',
        details: 'פרטים',
        mealSettings: 'הגדרות ארוחה',
        me: 'אני',
        delete: 'מחק',
        id: 'מזהה',
        copy: 'העתק',
        role: 'תפקיד',
        approve: 'אשר',
        decline: 'דחה',
        dismiss: 'התעלם',
        pending: 'ממתין',
        subscribed: 'מנוי',
        canceled: 'בוטל',
        declined: 'נדחה',
        subscriptionEnds: 'תוקף עד',
        actions: 'פעולות',
        email: 'אימייל',
        user: 'משתמש',
        currentStatus: 'סטטוס נוכחי',
        shareLinkText: 'שתף קישור',
        copyLink: 'העתק קישור',
        loginTitle: 'התחברות',
        loginBtn: 'התחבר',
        registerBtn: 'הרשמה',
        noAccount: "אין לך חשבון?",
        passwordPlaceholder: 'סיסמה',
        emailPlaceholder: 'אימייל',
        existingAccount: 'כבר יש לך חשבון?',
        welcome: 'ברוכים הבאים',
        copyFromCurrent: 'העתק מהנוכחי',
        weekStart: 'תחילת שבוע',
        startSunday: 'ראשון',
        startMonday: 'שני',
        day_Sunday: 'ראשון',
        day_Monday: 'שני',
        day_Tuesday: 'שלישי',
        day_Wednesday: 'רביעי',
        day_Thursday: 'חמישי',
        day_Friday: 'שישי',
        day_Saturday: 'שבת',
        searchResults: 'תוצאות חיפוש',
        noResults: 'לא נמצאו תוצאות',
        day: 'יום',
        schedule: 'תזמן',
        deleted: 'נמחק',
        scheduleInMenu: 'תזמן בתפריט',
        manageHouseholdsTitle: 'ניהול בתים',
        createNewHousehold: 'צור בית חדש',
        householdNamePlaceholder: 'לדוגמה: בית',
        visibleMealsLabel: 'ארוחות מוצגות',
        mustSelectOneMeal: 'חובה לבחור לפחות ארוחה אחת',
        cannotDisableAllMeals: 'לא ניתן לבטל את כל הארוחות',
        myHouseholdsTitle: 'הבתים שלי',
        mealSettingsTitle: 'הגדרות ארוחה',
        membersTitle: 'חברים',
        removeUserConfirm: 'האם אתה בטוח שברצונך להסיר משתמש זה?',
        removeUser: 'הסר משתמש',
        addUserPlaceholder: 'אימייל של משתמש',
        orderMeat: 'הזמן בשר',
        deleteHousehold: 'מחק בית',
        noHouseholdsToManage: 'אין בתים לניהול',
        copyId: 'העתק מזהה',
        householdLimitTitle: 'הגעת למגבלת הבתים',
        householdLimitDesc: 'הגעת למגבלה של {limit} בתים.',
        householdEntitlement: 'מכסת בתים',
        householdEntitlementHint: 'מספר הבתים שהמשתמש רשאי ליצור (ברירת מחדל 5).',
        createGuidedClient: 'יצירת לקוח מלווה',
        guidedClientCreated: 'הלקוח נוצר. העתק את קישור הגישה.',
        guidedClientLinkHint: 'שתף קישור מלא זה עם הלקוח. לא ניתן לשחזר אותו — השתמש ברענון קישור ליצירת קישור חדש.',
        myGuidedClients: 'הלקוחות שלי',
        guidedClientsAdmin: 'לקוחות מלווים',
        guidedClientsAdminAllHint: 'כל הלקוחות המלווים בכל היועצים.',
        guidedClientsAdminMineHint: 'הלקוחות המלווים שלך.',
        guidedClientsFilterActive: 'פעילים',
        guidedClientsFilterInactive: 'לא פעילים',
        guidedClientsFilterNotifications: 'עם הודעות',
        guidedClientsUnreadBadge: 'הודעה חדשה',
        backToClientList: 'חזרה לרשימה',
        assignedConsultant: 'יועץ',
        searchGuidedClients: 'חיפוש לפי שם או אימייל…',
        noGuidedClients: 'אין עדיין לקוחות מלווים.',
        selectGuidedClient: 'בחר לקוח לניהול.',
        selectConsultant: 'בחר יועץ…',
        knownAllergies: 'אלרגיות ידועות',
        knownAllergiesHint: 'הקש על האלרגנים הרלוונטיים.',
        allergyPeanuts: 'בוטנים',
        allergyTreeNuts: 'אגוזים',
        allergyMilk: 'חלב',
        allergyEggs: 'ביצים',
        allergyWheat: 'חיטה',
        allergyGluten: 'גלוטן',
        allergySoy: 'סויה',
        allergyFish: 'דגים',
        allergyShellfish: 'פירות ים',
        allergySesame: 'שומשום',
        allergyMustard: 'חרדל',
        allergyCelery: 'סלרי',
        allergySulphites: 'סולפיטים',
        allergyLupin: 'תורמוס',
        allergyMolluscs: 'רכיכות',
        allergyFavaBeans: 'פול',
        suitableForAllergies: 'מתאים לאלרגיות…',
        addAllergy: 'הוסף אלרגן',
        allAllergies: 'כל האלרגיות',
        addDiet: 'הוסף העדפה',
        allDiets: 'כל ההעדפות',
        dietFilterPickerTitle: 'בחר העדפות תזונה',
        allergyFilterPickerTitle: 'הסתר מתכונים עם אלרגנים אלה',
        allergyFilterInfoTitle: 'סינון אלרגיות',
        allergyFilterInfoBody: 'בחרו אלרגנים כדי להסתיר מתכונים שעשויים להכיל אותם. הזיהוי מבוסס על שמות מצרכים וייתכן שלא יזהה כל מקור.',
        allergyFilterDisclaimer: 'זהו סינון נוח בלבד — לא ייעוץ רפואי. תמיד קראו שוב רשימות מצרכים, תוויות ורכיבים לפני בישול או הגשה, במיוחד באלרגיות חמורות.',
        nutritionPrefsManagedHere: 'העדפות תזונה ניתן לעדכן כאן.',
        refreshAccessLink: 'רענון קישור גישה',
        openClientHousehold: 'פתיחת בית הלקוח',
        active: 'פעיל',
        inactive: 'לא פעיל',
        deactivateClientAccess: 'השבתה',
        guidedAccessSubtitle: 'הזן את כתובת האימייל שאיתה נרשמת אצל היועץ.',
        guidedAccessEmailPlaceholder: 'your@email.com',
        guidedAccessEmailMismatch: 'כתובת האימייל אינה תואמת להזמנה זו.',
        guidedAccessContinue: 'המשך',
        guidedAccessStandardLogin: 'התחברות עם סיסמה או Google',
        guidedAccessInvalidLink: 'קישור הגישה אינו תקין או שפג תוקפו.',
        guidedAccessFailed: 'לא ניתן להתחבר עם קישור זה.',
        proFeature: 'Pro',
        guidedClientContextBanner: 'ניהול לקוח:',
        guidedClientsHouseholdHint: 'פתח בית של לקוח מלווה דרך "לקוחות מלווים" תחת מנהל מערכת.',
        exitClientContext: 'יציאה מתצוגת לקוח',
        consultationBox: 'שאל את היועץ',
        goPro: 'שדרוג ל-Pro',
        goProDescription: 'שדרוג לחשבון מלא עם מתכונים ובתים משלך.',
        goProSetPassword: 'קביעת סיסמה ושדרוג',
        goProLinkGoogle: 'קישור Google ושדרוג',
        goProPasswordTooShort: 'הסיסמה חייבת להכיל לפחות 6 תווים.',
        goProPasswordMismatch: 'הסיסמאות אינן תואמות.',
        goProFailed: 'השדרוג נכשל. נסה שוב.',
        goProNoAccessRelation: 'לא נמצא קישור יועץ לפרופיל זה.',
        confirmPassword: 'אימות סיסמה',
        or: 'או',
        send: 'שליחה',
        consultationEmpty: 'אין הודעות עדיין. שאל את היועץ על התוכנית.',
        certifiedDietitian: 'דיאטנית מוסמכת',
        profileBio: 'תיאור פרופיל',
        profileBioPlaceholder: 'ספר ללקוחות קצת על עצמך…',
        consultantCertification: 'הסמכה',
        consultantCertificationPlaceholder: 'לדוגמה: דיאטנית קלינית מוסמכת',
        avatarUrl: 'קישור לתמונת פרופיל',
        avatarUrlPlaceholder: 'https://…',
        coverPhotoUrl: 'קישור לתמונת רקע',
        coverPhotoUrlPlaceholder: 'https://…',
        tapAvatarToEdit: 'לחץ על התמונה לעדכון הקישור',
        tapCoverToEdit: 'לחץ על תמונת הרקע לעדכון הקישור',
        planUpdated: 'התוכנית עודכנה',
        phraseOfTheDayAdmin: 'משפט היום',
        phraseOfTheDayHint: 'יוצג לכל בתי הלקוחות המלווים למשך {days} ימים לאחר הפרסום.',
        phraseOfTheDayCurrent: 'משפט נוכחי',
        phraseOfTheDayPlaceholder: 'כתוב מסר מוטיבציה קצר ללקוחות…',
        phraseOfTheDaySet: 'פרסם משפט',
        phraseOfTheDayPublishNew: 'פרסם כחדש',
        phraseOfTheDayHistory: 'היסטוריה',
        phraseOfTheDayHistoryEmpty: 'אין משפטים קודמים.',
        phraseOfTheDayExpires: 'פג תוקף',
        timeJustNow: 'עכשיו',
        timeMinuteAgo: 'לפני דקה',
        timeMinutesAgo: 'לפני {n} דקות',
        timeHourAgo: 'לפני שעה',
        timeHoursAgo: 'לפני {n} שעות',
        timeDayAgo: 'לפני יום',
        timeDaysAgo: 'לפני {n} ימים',
        consultationPlaceholder: 'כתוב שאלה…',
        consultationReplyPlaceholder: 'תשובה ללקוח…',
        duplicateForHousehold: 'העתק לבית זה',
        personalDetailsWarning: 'אנא מלא את פרטיך האישיים',
        termsOfService: 'תנאי שימוש',
        text: 'טקסט',
        link: 'קישור',
        nameLabel: 'שם',
        sourceLanguageLabel: 'שפת מקור',
        weeklyCarts: 'עגלות שבועיות',
        shoppingCarts: 'עגלות קניות',
        addCart: 'הוסף עגלה',
        editCart: 'ערוך עגלה',
        deleteCart: 'מחק עגלה',
        weeksMultiplier: 'מכפיל שבועות',
        combineCarts: 'אחד עגלות',
        viewRecipes: 'צפה במתכונים',
        viewChefRecipes: 'צפה ב-{count} מתכונים',
        viewRecipe: 'צפה במתכון',
        viewIngredients: 'צפה במרכיבים',
        viewCarts: 'צפה בעגלות',
        cartLabel: 'שם העגלה',
        noPlanToCopy: 'אין תכנית קודמת להעתקה',
        aiLoadingMsg: 'רגע...',
        saveLoadingMsg: 'שומר...',
        aiStep_reading: 'קורא מתכון',
        aiStep_analyzing: 'מנתח',
        aiStep_ingredients: 'מעבד מרכיבים',
        aiStep_prepSteps: 'בונה שלבי הכנה',
        aiStep_nutrition: 'מנתח ערכים תזונתיים',
        aiStep_allergensDiet: 'מנתח אלרגנים והתאמת תזונה',
        aiStep_saving: 'שומר',
        recipeSavePending: 'מכין מתכון…',
        recipeSavePendingHint: 'אפשר לעזוב — נסיים ברקע',
        activeCart: 'עגלה פעילה',
        remaining: 'נותר',
        itemMoved: 'פריט הועבר',
        undo: 'בטל',
        done: 'בוצע',
        addToActive: 'הוסף לעגלה פעילה',
        inActiveCart: 'בעגלה',
        addItem: 'הוסף פריט',
        miscItems: 'פריטים שונים',
        moveToCart: 'העבר לעגלה',
        newCart: 'עגלה חדשה',
        unit: 'יחידה',
        quantity: 'כמות',
        searchOrAdd: 'חפש או הוסף פריט',
        revert: 'בטל',
        markDone: 'סמן כבוצע',
        markUndone: 'סמן כלא בוצע',
        markComplete: 'סמן שלב כבוצע',
        markIncomplete: 'סמן שלב כלא בוצע',
        markRecipeDone: 'סמן מתכון כמוכן',
        recipeDone: 'המתכון מוכן',
        recipeReadyBadge: 'מוכן',
        recipeInProgressBadge: 'בהכנה',
        mealDonePromptTitle: 'כל המתכונים מוכנים!',
        mealDonePromptMessage: 'כל שלבי ההכנה הושלמו. לסמן את הארוחה כמוכנה?',
        markMealDone: 'סמן ארוחה כמוכנה',
        mealCompletedTitle: 'הארוחה מוכנה',
        mealCompletedMessage: 'כל הכבוד — סיימתם את הארוחה.',
        viewMenu: 'צפה בתפריט',
        deleteSelected: 'מחק נבחרים',
        clearCompleted: 'נקה שהושלמו',
        shareList: 'שתף רשימה',
        emptyCart: 'רוקן עגלה',
        cartIsEmpty: 'העגלה ריקה',
        emptyCartConfirm: 'האם אתה בטוח שברצונך לרוקן את העגלה?',
        clearCompletedConfirm: 'האם אתה בטוח שברצונך למחוק פריטים שהושלמו?',
        hideDone: 'הסתר שבוצעו',
        showDone: 'הצג שבוצעו',
        allCollected: 'נאסף הכל',
        today: 'היום',
        tomorrow: 'מחר',
        defrost: 'להפשיר',
        defrostForMeal: 'להפשיר ל{meal} · {day}',
        buy: 'לקנות',
        reminder: 'תזכורת',
        veggieDay: 'יום צמחוני',
        getStarted: 'התחל',
        appWarmingUp: 'מחממים את האש...',
        fastingTimer: 'טיימר צום',
        fastingStart: 'התחל צום',
        fastingStop: 'עצור',
        fastingStatistics: 'סטטיסטיקת צום',
        fastingNoHistory: 'אין עדיין היסטוריית צום.',
        fastingHoursShort: ' ש\' ',
        fastingMinutesShort: ' ד\'',
        fastingSecondsShort: ' שנ׳',
        fastingGoalHours: 'יעד: {hours} שעות',
        fastingHoursGoal: '{hours} שעות',
        tapToManage: 'הקש לניהול',
        fastingEndsAt: 'מסתיים ב-{time}',
        fastingEndsAtTomorrow: 'מסתיים מחר ב-{time}',
        fastingTimeRemaining: 'זמן שנותר',
        fastingStartFasting: 'התחל צום',
        fastingStartNow: 'התחל עכשיו',
        fastingChangeGoal: 'שנה יעד',
        fastingEndFast: 'סיים צום',
        fastingEditGoal: 'ערוך יעד',
        fastingGoalReached: 'היעד הושג!',
        fastingSaveFast: 'שמור צום',
        fastingRemainingLeft: 'נותרו {time}',
        fastingCountdownRemaining: 'נותרו {time}',
        fastingOpenModal: 'פתח טיימר צום',
        fastingIdleHint: 'לחץ התחל כשאתה מתחיל את חלון הצום.',
        intermittentFastingSetting: 'צום לסירוגין',
        intermittentFastingSettingDesc: 'הצג את טיימר הצום בכותרת. התראות בסיום הצום פועלות כשהאפליקציה מותקנת.',
        allowHouseholdInvitationsSetting: 'אפשר הוספה לבתים אחרים',
        allowHouseholdInvitationsSettingDesc: 'אפשר למשתמשים אחרים להזמין אותך להצטרף לבית שלהם. אם מושבת, לא ניתן יהיה למצוא אותך לפי אימייל.',
        householdInvitationMsg: 'הוזמנת להצטרף לבית "{name}".',
        approveInvitation: 'אישור',
        rejectInvitation: 'דחייה',
        membersHeader: 'חברים',
        invitedHeader: 'בהמתנה להזמנה',
        rejectedHeader: 'סירבו להזמנה',
        tenantsHeader: 'דיירים נוספים',
        addTenant: 'הוסף דייר/ילד',
        editTenant: 'ערוך דייר/ילד',
        tenantName: 'שם הדייר',
        birthday: 'תאריך לידה',
        nutritionProfile: 'פרופיל תזונתי',
        noTenants: 'אין דיירים רשומים עדיין',
        isChildLabel: 'ילד/ה?',
        isTenantLabel: 'דייר/ת?',
        childBadge: 'ילד/ה',
        adultBadge: 'מבוגר/ת',
        allergiesTitle: 'אלרגיות',
        showDetails: 'הצג דיאטה/אלרגיות',
        hideDetails: 'הסתר דיאטה/אלרגיות',
        noPreferences: 'אין מגבלות תזונה',
        userNotFound: 'משתמש לא נמצא',
        userAlreadyMember: 'המשתמש כבר חבר בבית זה',
        userAlreadyInvited: 'משתמש זה כבר מוזמן',
        invitationSent: 'ההזמנה נשלחה בהצלחה!',
        errorSendingInvitation: 'שגיאה בשליחת ההזמנה',
        fastingNotificationTitle: 'הצום הסתיים!',
        fastingNotificationBody: 'צום של {hours} שעות הסתיים. אפשר לאכול.',
        fastingStartNotificationTitle: 'הגיע זמן הצום!',
        fastingStartNotificationBody: 'צום של {hours} שעות מתחיל עכשיו.',
        fastingScheduleLater: 'תזמן לעתיד',
        fastingSetStartTime: 'קבע שעת התחלה',
        fastingSchedule: 'תזמן צום',
        fastingScheduledTitle: 'צום מתוזמן',
        fastingTarget: 'יעד',
        fastingTargetHours: 'יעד: {hours} שעות',
        fastingCancelSchedule: 'ביטול הצום',
        confirmDeleteFastingSessionTitle: 'מחיקת צום',
        confirmDeleteFastingSession: 'האם אתה בטוח שברצונך למחוק צום זה?',
        fastingEditStartLabel: 'זמן התחלה',
        fastingEditEndLabel: 'זמן סיום',
        fastingActive: 'פעיל',
        fastingStartsAt: 'מתחיל ב-{time}',
        fastingStartsAtTomorrow: 'מתחיל מחר ב-{time}',
        fastingStartsIn: 'מתחיל בעוד {time}',
        fastingEditStartTime: 'ערוך שעת התחלה',
        fastingStartTime: 'שעת התחלה',
        fastingSaveStartTime: 'שמור שעת התחלה',
        fastingGoalDialHint: 'גרור את הגלגל או בחר יעד מוכן',
        fastingWeeklyChart: '14 הימים האחרונים',
        fastingClearSelection: 'נקה בחירה',
        fastingAddEntry: 'הוסף רשומה',
        fastingAddEntryTitle: 'הוספת רשומת צום',
        tutorial_step1: 'מתכונים וחיפוש',
        tutorial_step2: 'תכנון וסנכרון עגלה',
        tutorial_step3: 'עגלות קניות',
        tutorial_step4: 'סנכרון בזמן אמת',
        tutorial_step5: 'העדפות וצום',
        tutorial_step6: 'משק בית ושיתוף',
        tutorial_plan_step1_title: 'מעבר שבועי / חודשי',
        tutorial_plan_step1_desc: 'מעבר מהיר בין תפריט שבועי מפורט למבט על ברמה החודשית.',
        tutorial_plan_step2_title: 'סטטיסטיקה והרגלים',
        tutorial_plan_step2_desc: 'מעקב אחר צריכת הבשר הביתית ותכנון ארוחות מאוזנות לאורך זמן.',
        tutorial_recipe_step1_title: 'יבוא חכם עם בינה מלאכותית',
        tutorial_recipe_step1_desc: 'הפכו כל מתכון לאוסף הפרטי שלכם באופן מיידי! הדביקו קישור למתכון מאתר מתכונים או פוסט מאינסטגרם/פייסבוק ל-MealPai, והבינה המלאכותית שלנו תחלץ עבורכם את המרכיבים וההוראות אוטומטית.',
        tutorial_recipe_step2_title: 'חיפוש וסינון',
        tutorial_recipe_step2_desc: 'מצאו בדיוק את מה שאתם מחפשים בעזרת חיפוש עוצמתי ומסננים חכמים (כמו זמן הכנה או תגיות תזונתיות).',
        tutorial_recipe_step3_title: 'פעולות גורפות',
        tutorial_recipe_step3_desc: 'בחרו מספר מתכונים כדי לתזמן אותם ביומן או להוסיף את המרכיבים שלהם לעגלת הקניות שלכם בבת אחת!',
        tutorial_recipe_step4_title: 'מועדפים והתאמה אישית',
        tutorial_recipe_step4_desc: 'סמנו מתכונים כמועדפים לגישה מהירה, ערכו אותם לטעמכם, או שתפו אותם עם בני הבית.',
        tutorial_plan_step3_title: 'סנכרון לסל הקניות',
        tutorial_plan_step3_desc: 'ריכוז אוטומטי של כל המרכיבים הנדרשים לארוחות המתוכננות ישירות לסל הקניות הפעיל.',
        tutorial_plan_step4_title: 'ניווט תאריכים',
        tutorial_plan_step4_desc: 'מעבר קדימה ואחורה בזמן כדי לתכנן את התפריטים מראש או לצפות בהיסטוריה.',
        tutorial_plan_step5_title: 'מצפן חכם',
        tutorial_plan_step5_desc: 'הלכתם לאיבוד? חזרו מיד לשבוע או לחודש הנוכחיים בלחיצה אחת.',
        tutorial_plan_step6_title: 'תכנון ארוחה',
        tutorial_plan_step6_desc: 'לחצו על כפתור הפלוס (+) בכל שורה כדי לבחור או לחפש מתכונים ולשבץ אותם בתפריט.',
        tutorial_plan_step7_title: 'התחלת בישול',
        tutorial_plan_step7_desc: 'לחצו על אייקון סיר הבישול כדי להתחיל סשן בישול מודרך עבור כל הארוחות המתוכננות לאותו זמן.',
        tutorial_desc1: 'חפש, גלה והוסף מתכונים באופן ידני או מיידית בעזרת ה-AI. חקור תכונות מתכונים כולל סשן בישול, הכנת רכיבים והנחיות שלב אחר שלב.',
        tutorial_desc2: 'תכנן את הארוחות שלך לפי שבוע או חודש. הוספת מתכונים למתכנן מחשבת אוטומטית את הרכיבים הדרושים ומסנכרנת אותם ישירות לעגלת הקניות שלך.',
        tutorial_desc3: 'נהל מספר עגלות קניות במקביל. הצג פריטים מקובצים לפי קטגוריה, סמן מה שכבר יש לך, ערוך רשימות ועקוב אחר קניות המזון שלך.',
        tutorial_desc4: 'עגלת הקניות הפעילה שלך מסונכרנת בזמן אמת. שינויים שמבוצעים על ידי חברי בית אחרים מתעדכנים באופן מיידי, כך שכולם נשארים מתואמים.',
        tutorial_desc5: 'התאם אישית את הפרופיל שלך עם העדפות תזונה והנחיות דיאטה. עקוב אחר סשני צום לסירוגין עם בקרה ידנית להתחלה וסיום כדי לבנות הרגלים בריאים.',
        tutorial_desc6: 'נהל את משק הבית שלך, הזמן חברים נוספים והתאם אישית את השיתוף. מעבר בקלות בין חשבון אישי למשפחתי מסנכרנת את התכנונים והרשימות.',
        tutorial_tip1: 'תכונות מתכונים וייבוא AI',
        tutorial_tip2: 'ארוחות שבועיות וחודשיות',
        tutorial_tip3: 'קיבוץ חכם לפי קטגוריות',
        tutorial_tip4: 'סנכרון עגלה פעילה',
        tutorial_tip5: 'העדפות תזונה וצום',
        tutorial_tip6: 'ניהול משק הבית',
        tutorial_tip_public: 'שתף עם הקהילה',
        previous: 'הקודם',
        nextStep: 'הבא',
        gotIt: 'הבנתי',
        skip: 'דלג',
        recipeAlreadyScheduledTitle: 'המתכון כבר מתוזמן',
        recipeAlreadyScheduledMsg: 'כבר מתוזמן ל-',
        tutorial_step: 'שלב',
        viewBooklet: 'צפה בחוברת',
        contactBody: 'צור איתנו קשר לכל שאלה או תמיכה.',
        sendEmailBtn: 'שלח אימייל',
        addNewSection: 'הוסף מחלקה חדשה',
        orWithEmail: 'או עם אימייל',
        agreeToTerms: 'אני מסכים לתנאי השימוש',
        loginHeader: 'התחבר לחשבונך',
        registerHeader: 'צור חשבון חדש',
        googleLogin: 'התחבר עם גוגל',
        migrationConfirm: 'אשר מיגרציה',
        migrateLegacyRecipeOwnership: 'שייך בעלות למתכונים ישנים',
        migrateLegacyRecipeOwnershipDone: 'בעלות עודכנה עבור {n} מתכונים ישנים.',
        migrateLegacyRecipeOwnershipNone: 'לא נמצאו מתכונים ישנים שדורשים שיוך בעלות במשק הבית.',
        migrateLegacyRecipeOwnershipConfirm: 'לשייך בעלות למתכונים',
        migrateLegacyRecipeOwnershipFailed: 'מיגרציית בעלות המתכונים נכשלה.',
        migrationsPanelTitle: 'מיגרציות נתונים',
        migrations: 'מיגרציות',
        migrateChefLinks: 'מיגרציית קישורי שפים',
        migrateChefLinksConfirm: 'לתקן ולאחד קישורים עבור',
        migrateChefLinksDone: 'קישורי שפים עודכנו עבור {n} שפים.',
        migrateChefLinksNone: 'כל קישורי השפים כבר מעודכנים.',
        migrateChefLinksFailed: 'מיגרציית קישורי השפים נכשלה.',
        migrateRecipeChefFromLinks: 'שייך שפים למתכונים מקישור מקור',
        migrateRecipeChefFromLinksConfirm: 'לשייך שפים מקישור המקור עבור',
        migrateRecipeChefFromLinksDone: 'שיוך שף עודכן עבור {n} מתכונים מקישור המקור.',
        migrateRecipeChefFromLinksNone: 'לא נמצאו מתכונים ללא שף שמתאימים לשף קיים מקישור המקור.',
        migrateRecipeChefFromLinksFailed: 'מיגרציית שיוך שפים למתכונים נכשלה.',
        migrateRecipeFilterMetadata: 'נרמול מטא-דאטה לסינון מתכונים',
        migrateRecipeFilterMetadataConfirm: 'לנרמל מטא-דאטה לסינון עבור',
        migrateRecipeFilterMetadataDone: 'מטא-דאטה לסינון עודכן עבור {n} מתכונים.',
        migrateRecipeFilterMetadataNone: 'לכל המתכונים כבר יש מטא-דאטה מנורמל לסינון.',
        migrateRecipeFilterMetadataFailed: 'מיגרציית מטא-דאטה לסינון מתכונים נכשלה.',
        fixSuccess: 'תיקון הצליח',
        overallRating: 'דירוג כללי',
        agreeContinue: 'אשר והמשך',
        to: 'ל',
        prep: 'הכנה',
        for: 'עבור',
        deleteItems: 'מחק פריטים',
        collapse: 'צמצם',
        showAll: 'הצג הכל',
        plan_free: 'חינם',
        plan_free_for_life: 'חינם לכל החיים',
        cookMeal: 'בשל ארוחה',
        prepTab: 'הכנות',
        prepGatherIngredients: 'אספו את כל המרכיבים לפני שמתחילים',
        cookingMeal: 'מבשלים {meal}',
        gatherIngredients: 'איסוף מצרכים',
        printMenu: 'הדפס תפריט',
        mealNamePlaceholder: 'תן שם לארוחה...',
        editMealName: 'ערוך שם ארוחה',
        startPrep: 'התחל הכנה',
        prepTimelineTitle: 'ציר זמן הכנה',
        prepTimelineStartNow: 'התחל עכשיו',
        prepTimelineTargetTime: 'שעת הגשה',
        prepTimelineReadyBy: 'מוכן עד',
        prepTimelineFinishBy: 'הכל מוכן עד',
        prepTimelineStartBy: 'התחל את המשימה המוקדמת ביותר ב',
        prepTimelineAnalyzing: 'מנתח שלבי הכנה...',
        prepTimelineAnalyzingHint: 'ה-AI מעריך זמני עבודה והמתנה מהמתכונים שלך.',
        prepTimelineFallbackNotice: 'משתמש בזמנים משוערים — ניתוח AI לא היה זמין.',
        prepTimelineFallbackInvalidKey: 'משתמש בזמנים משוערים — מפתח Gemini האישי לא תקין. עדכן אותו בהגדרות הפרופיל.',
        prepTimelineFallbackRateLimited: 'משתמש בזמנים משוערים — יותר מדי בקשות. המתן דקה ונסה שוב.',
        prepTimelineChart: 'ציר זמן',
        prepTimelineTotal: 'סה"כ',
        prepTimelineStartAt: 'התחל ב',
        prepTimelineReadyAt: 'מוכן ב',
        prepTimelineWait: 'המתנה:',
        prepTimelineActive: 'פעיל',
        prepTimelineActiveWork: 'עבודה פעילה',
        prepTimelinePassiveWait: 'המתנה פסיבית (מקרר, מנוחה, מרינדה)',
        prepTimelineStartPreviousDay: 'יש להתחיל בהכנה יום קודם',
        prepTimelineReadyNextDay: 'יהיה מוכן למחרת',
        prepTimelineStartCooking: 'התחל בישול',
        prepTimelineSessionActive: 'בהכנה',
        prepTimelineStartedAt: 'התחיל ב-{time}',
        prepTimelineStartTimeLabel: 'שעת התחלה',
        prepTimelineResetStartTime: 'אפס שעת התחלה',
        prepTimelineAdjustStartTime: 'שנה שעת התחלה',
        prepTimelineAdjustStartTitle: 'שנה שעת התחלה',
        prepTimelineAdjustStartMessage: 'אפס לשעה הנוכחית, או הגדר מתי באמת התחלת להכין.',
        prepTimelineResetToNow: 'אפס לעכשיו',
        prepTimelineSetActualStartTime: 'הגדר שעת התחלה בפועל',
        prepTimelineSetStartTime: 'הגדר שעת התחלה',
        prepTimelineTargetAssumedStarted: 'ההכנה הותחלה ב-{time} כדי לעמוד ביעד',
        prepTimelineStopSession: 'עצור הכנה',
        prepTimelineStopSessionConfirmTitle: 'לעצור את ההכנה?',
        prepTimelineStopSessionConfirmMessage: 'ציר הזמן יחזור למצב תכנון.',
        prepTimelineApplyStartTime: 'החל',
        prepTimelineHeatDefrost: 'חימום / הפשרה',
        prepTimelineIncludeInChart: 'כלול בציר הזמן',
        prepTimelineOvernight: 'הכנה ללילה',
        prepTimelineStartLater: 'התחלה מאוחרת',
        prepTimelineFinishEarly: 'מוכן מוקדם',
        instructionStepDuration: 'משך (דקות)',
        instructionStepDurationOptional: 'אופציונלי — לציר זמן ההכנה',
        backToMenu: 'חזרה לתפריט',
        creditsAndSources: 'קרדיטים ומקורות',
        addSource: 'הוסף מקור',
        creditOriginNote: 'קרדיט / הערת מקור',
        pasteUrlPlaceholder: 'הדבק כתובת URL...',
        originNotePlaceholder: 'לדוגמה: המתכון של סבתא',
        newSection: 'מחלקה חדשה',
        sectionNamePlaceholder: 'שם מחלקה',
        newSectionNamePlaceholder: 'שם מחלקה חדשה',
        moveToSection: 'העבר למחלקה',
        organizeList: 'ארגן רשימה',
        orCreateNewSection: 'או צור מחלקה חדשה',
        confirmMove: 'אשר העברה',
        moveToList: 'העבר לרשימה',
        selectTargetList: 'בחר רשימת יעד',
        noOtherLists: 'אין רשימות אחרות',
        orCreateNewList: 'או צור רשימה חדשה',
        newListNamePlaceholder: 'שם רשימה חדשה',
        deselectAll: 'בטל בחירה',
        updatingList: 'מעדכן רשימה...',
        duplicate: 'כפילות',
        ingredientDuplicateInSection: '"{name}" כבר קיים במחלקה "{section}".',
        confirmDeleteNamedItem: 'למחוק את "{name}"?',
        confirmDeleteItemCount: 'למחוק {count} פריטים?',
        confirmDeleteSection: 'למחוק את המחלקה "{section}" ואת כל המרכיבים שבה?',
        confirmDeleteCart: 'למחוק את "{name}"?',
        prepSectionPlaceholder: 'שם מחלקה',
        addStepTo: 'הוסף שלב ל{section}',
        describeStepPlaceholder: 'תאר את השלב...',
        moveUp: 'הזז שלב למעלה',
        moveDown: 'הזז שלב למטה',
        unsavedRecipeChangesTitle: 'יש שינויים שלא נשמרו',
        unsavedRecipeChangesMessage: 'ביצעת שינויים במתכון. לשמור עכשיו או לצאת בלי לשמור?',
        saveNow: 'שמור עכשיו',
        discardChanges: 'צא בלי לשמור',
        keepEditing: 'המשך לערוך',
        viewFullWeek: 'צפה בשבוע מלא',
        monthLast: 'חודש שעבר',
        monthNext: 'חודש הבא',
        monthCurrent: 'החודש',
        vegetables: 'ירקות',
        others: 'אחרים',
        manual: 'ידני',
        sourcing_buy: 'לקנות',
        sourcing_pantry: 'מזווה',
        sourcing_prepared: 'מוכן',
        skip_shopping_list_hint: 'לא יתווסף לרשימת קניות',
        deleteMealConfirm: 'למחוק ארוחה זו?',
        systemUserManagement: 'ניהול משתמשים',
        totalUsers: 'סה"כ משתמשים',
        searchUsers: 'חפש משתמשים',
        allRoles: 'כל התפקידים',
        sortByDateAdded: 'תאריך הצטרפות',
        sortByName: 'שם',
        superusers: 'מנהלי על',
        admins: 'מנהלים',
        users: 'משתמשים',
        fixPlanMetadata: 'תקן מטא-דאטה של תכניות',
        fixUserMetadata: 'תקן מטא-דאטה של משתמשים',
        usageStatistics: 'סטטיסטיקות שימוש',
        systemRole: 'תפקיד מערכת',
        userType: 'סוג משתמש',
        userTypeRegular: 'משתמש רגיל',
        userTypeNutritionConsultant: 'יועץ תזונה',
        allUserTypes: 'כל סוגי המשתמשים',
        subscription: 'מנוי',
        initialize: 'אתחול',
        cancelPlan: 'בטל מנוי',
        activate: 'הפעל',
        confirmCancelPlan: 'לבטל את המנוי עבור {email}?',
        confirmCancelPlanHint: 'המשתמש יאבד גישה עם סיום תקופת המנוי הנוכחית.',
        approveNewSubscriptions: 'אישור מנויים חדשים',
        approveSubscription: 'אשר מנוי',
        approveSubscriptionHint: 'בחר חינם לכל החיים, או הגדר תאריך תפוגה.',
        noPendingSubscriptions: 'אין בקשות הצטרפות חדשות.',
        subscriptionEndDateRequired: 'יש לבחור תאריך תפוגה.',
        joined: 'הצטרף',
        ends: 'מסתיים',
        recipesOwned: 'מתכונים בבעלות',
        householdsOwned: 'בתים בבעלות',
        otherMemberships: 'חברות בבתים אחרים',
        statistics: 'סטטיסטיקות',
        userRecipes: 'מתכוני משתמש',
        userHouseholds: 'בתי משתמש',
        unnamedItem: 'פריט ללא שם',
        noItemsFound: 'לא נמצאו פריטים',
        backToSummary: 'חזרה לסיכום',
        userDetails: 'פרטי משתמש',
        userId: 'מזהה משתמש',
        termsAccepted: 'תנאים אושרו',
        yes: 'כן',
        no: 'לא',
        idCopied: 'מזהה הועתק',
        suggestionBox: 'תיבת הצעות',
        addSuggestion: 'הוסף הצעה',
        mySuggestions: 'ההצעות שלי',
        manageSuggestions: 'ניהול הצעות',
        chef: 'שף',
        chefs: 'שפים',
        chefCredit: 'קרדיט שף',
        selectChef: 'בחר שף...',
        filterByChef: 'סינון לפי שף',
        addChef: 'הוסף שף',
        requestChefRecognition: 'בקשת הכרה כשף',
        requestNewChef: 'בקש שף חדש',
        linkExistingChef: 'קישור לשף קיים',
        verifiedChef: 'שף מאומת',
        viewChefCard: 'צפה בכרטיס השף',
        editChefProfile: 'עריכת פרופיל שף',
        manageChefs: 'ניהול שפים',
        chefProfile: 'פרופיל שף',
        chefWebsite: 'אתר',
        chefLinks: 'קישורים',
        chefLinkPlaceholder: 'https:// או @instagram',
        chefLinksHint: 'אתר, פרופיל אינסטגרם, יוטיוב וכו׳.',
        chefAutoCredited: 'השף {name} נוסף אוטומטית מאינסטגרם.',
        removeLink: 'הסר קישור',
        analyzeFailed: 'ניתוח המתכון נכשל. נסו שוב.',
        recipeNotRecipeMsg: 'הטקסט לא נראה כמו מתכון. הדביקו מתכון עם מצרכים והוראות הכנה.',
        recipeInappropriateMsg: 'לא ניתן לנתח תוכן זה. הסירו שפה פוגענית או לא הולמת ונסו שוב.',
        recipeContentNotRecipeTitle: 'זה לא מתכון',
        recipeContentNotRecipeMsg: 'הטקסט לא נראה כמו מתכון. הדביקו מתכון עם מצרכים והוראות הכנה.',
        recipeContentMisconductTitle: 'תוכן לא הולם',
        recipeContentMisconductBody: 'התוכן שהוזן כולל שפה לא נאותה ואינו מהווה מתכון אמיתי. אנא הקפידו על תוכן מכבד ומתאים לכל המשפחה.',
        recipeContentMisconductBlockingWarning: 'שימוש לרעה חוזר באפליקציה עלול להוביל לחסימת החשבון שלך.',
        scraperUnavailableTitle: 'לא זמין כרגע',
        scraperUnavailableMsg: 'האפשרות הזו אינה זמינה כרגע ותחזור בקרוב — אנחנו עובדים על התקלה. נסו שוב מאוחר יותר או הדביקו את טקסט המתכון במקום.',
        recipeAlreadyExistsTitle: 'המתכון כבר קיים',
        recipeAlreadyExistsMsg: 'מתכון משותף מהסרטון הזה כבר קיים: "{name}". פתחו אותו במקום לייבא שוב.',
        recipeSharingConflictMsg: 'מתכון ציבורי או משותף אחר כבר משתמש בסרטון המקור הזה. פתחו את המתכון הקיים או השאירו את זה פרטי.',
        chefRequests: 'בקשות שפים',
        approveChefRequest: 'אשר',
        denyChefRequest: 'דחה',
        importChefCsv: 'ייבוא CSV',
        exportChefCsv: 'ייצוא CSV',
        importChefCsvShort: 'ייבוא',
        exportChefCsvShort: 'ייצוא',
        newChefShort: 'שף חדש',
        mergeChefsShort: 'מיזוג',
        importChefCsvConfirm: 'לייבא שפים מקובץ CSV? שפים קיימים יקבלו רק השלמה של שדות חסרים.',
        importChefCsvDone: 'ייבוא CSV הושלם',
        newChef: 'שף חדש',
        originLanguage: 'שפת מקור',
        updated: 'עודכנו',
        hebrew: 'עברית',
        english: 'אנגלית',
        originCountry: 'אזור',
        region: 'אזור',
        country_israel: 'ישראל',
        country_united_states: 'ארצות הברית',
        country_united_kingdom: 'בריטניה',
        country_france: 'צרפת',
        country_italy: 'איטליה',
        country_spain: 'ספרד',
        country_germany: 'גרמניה',
        country_mexico: 'מקסיקו',
        country_morocco: 'מרוקו',
        country_turkey: 'טורקיה',
        country_lebanon: 'לבנון',
        country_greece: 'יוון',
        country_japan: 'יפן',
        country_china: 'סין',
        country_india: 'הודו',
        country_thailand: 'תאילנד',
        country_brazil: 'ברזיל',
        country_argentina: 'ארגנטינה',
        country_canada: 'קנדה',
        country_australia: 'אוסטרליה',
        country_netherlands: 'הולנד',
        country_belgium: 'בלגיה',
        country_switzerland: 'שווייץ',
        country_austria: 'אוסטריה',
        country_portugal: 'פורטוגל',
        country_poland: 'פולין',
        country_egypt: 'מצרים',
        country_south_korea: 'דרום קוריאה',
        country_vietnam: 'וייטנאם',
        country_iran: 'איראן',
        country_syria: 'סוריה',
        country_jordan: 'ירדן',
        country_palestine: 'פלשתינה',
        country_tunisia: 'תוניסיה',
        country_ethiopia: 'אתיופיה',
        country_iraq: 'עיראק',
        country_yemen: 'תימן',
        country_russia: 'רוסיה',
        country_ukraine: 'אוקראינה',
        chefName: 'שם',
        chefEnglishName: 'שם באנגלית',
        chefDescription: 'תיאור',
        chefDescriptionPlaceholder: 'תיאור קצר או כותרת…',
        chefInstagramUsername: 'שם משתמש באינסטגרם',
        chefInstagramUsernameHint: 'משמש לרענון שם, תיאור ותמונה מאינסטגרם.',
        chefInstagramUserId: 'מזהה משתמש באינסטגרם',
        chefInstagramUserIdHint: 'מספר pk של אינסטגרם (מתמלא אוטומטית מפוסטים או רענון).',
        chefInstagramUsernameRequired: 'הזינו שם משתמש באינסטגרם לרענון.',
        chefInstagramRefreshFailed: 'לא ניתן לרענן מאינסטגרם. נסו שוב מאוחר יותר.',
        refreshFromInstagram: 'רענון',
        mergeChefs: 'מיזוג שפים',
        mergeChefsHint: 'בחרו שף לשמור ושף למזג אליו. מתכונים וקישורים יעברו לשף שנשמר.',
        mergeKeepChef: 'שף לשמור',
        mergeRemoveChef: 'שף למזג ולהסיר',
        mergeRecipesNotice: '{count} מתכונים יועברו.',
        mergePreview: 'תצוגה מקדימה',
        mergeConfirm: 'מזג',
        mergeSuccessSummary: '{merged} מוזג לתוך {kept}.',
        mergeRecipesUpdated: '{count} מתכונים עודכנו.',
        mergeUsersUpdated: '{count} משתמשים מקושרים עודכנו.',
        mergeFavoritesUpdated: '{count} רשימות מועדפים עודכנו.',
        searchChefsPlaceholder: 'חיפוש לפי שם או כינוי…',
        chefRequestNameRequired: 'נא להזין שם',
        chefRequestPending: 'יש לך כבר בקשה ממתינה',
        noPendingRequests: 'אין בקשות ממתינות',
        message: 'הודעה',
        submit: 'שלח',
        errorSaving: 'שגיאה בשמירה',
        edit: 'ערוך',
        editChef: 'עריכת שף',
        disableChef: 'השבת שף',
        disableChefHint: 'לא יוצג בקרדיטים ובחירת שפים במתכונים',
        chefImageUrl: 'קישור לתמונה',
        skipped: 'דולגו',
        total: 'סה"כ',
        linked: 'מקושר',
        disabled: 'מושבת',
        chefNicknameLocked: 'שף זה משויך לחשבון מאומת',
        nicknameReserved: 'כינוי זה שמור לשף מאומת',
        subject: 'נושא',
        area: 'תחום',
        status: 'סטטוס',
        reporter: 'מדווח',
        archive: 'ארכיון',
        new: 'חדש',
        fulfilled: 'בוצע',
        denied: 'נדחה',
        approved: 'אושר',
        allStatuses: 'כל הסטטוסים',
        shopping: 'קניות',
        planner: 'תכנון',
        household: 'בית',
        other: 'אחר',
        whatAreWeCooking: 'מה מבשלים?',
        chefAssistantSubtitle: 'הדבק קישור או טקסט לייבוא מתכון',
        chefAssistantPlaceholder: 'הדבק כאן קישור או טקסט...',
        pasteFromClipboard: 'הדבק מלוח ההעתקה',
        addLink: 'הוסף קישור',
        scanImageBeta: 'סרוק תמונה (בטא)',
        analyzeWithAI: 'נתח עם AI',
        editManually: 'ערוך ידנית',
        saveToKitchen: 'שמור למטבח',
        ingredientsList: 'רשימת מרכיבים',
        recipeName: 'שם המתכון',
        reviewingNewMeal: 'סקירת מנה חדשה',
        markAsMeat: 'סמן כבשרי',
        connectingSousChef: 'מתחבר לשף עוזר...',
        proc_reading: 'קורא מתכון...',
        proc_proteins: 'מנתח חלבונים...',
        proc_ingredients: 'מעבד מרכיבים...',
        proc_steps: 'מארגן שלבים...',
        proc_finalizing: 'מסיים עיבוד...',
        mins: 'דק\'',
        theme: 'מראה',
        themeLight: 'בהיר',
        themeDark: 'כהה',
        themeSystem: 'מערכת',
        fontSize: 'גודל גופן',
        fontSizeSystem: 'מערכת',
        fontSizeCustom: 'מותאם אישית',
        fontSmall: 'קטן',
        fontDefault: 'רגיל',
        fontLarge: 'גדול',
        exportRecipe: 'ייצא מתכון',
        copyText: 'העתק טקסט',
        textCopied: 'הטקסט הועתק!',
        unite: 'אחד',
        navigation: 'ניווט',
        quantityToMake: 'כמות להכנה',
        servingsPerMeal: 'מנות לארוחה',
        recipeDefaultServingsHint: 'ברירת מחדל במתכון: {count} מנות',
        totalServings: 'סה״כ מנות',
        futureMealsNoticeTitle: 'טיפ להכנה מרוכזת',
        futureMealsPlannedHint: 'המתכון {recipe} מתוכנן גם בימים: {days}. (סה"כ: {totalServings} מנות ב-{totalMeals} ארוחות)',
        scaleToTotalServings: 'עדכן לסה״כ ({count} מנות)',
        duration_repeat: 'משך / חזרה',
        schedule_days_hint: 'יופיע למשך {count} ימים רצופים',
        schedule_weeks_hint: 'חוזר כל יום {day} למשך {count} שבועות',
        unknownRecipe: 'מתכון לא ידוע',
        lists: 'רשימות',
        sort_recent: 'נוספו לאחרונה',
        sort_rated: 'דירוג גבוה',
        filterByRating: 'דירוג',
        filterRatingAndUp: '{stars}+ כוכבים',
        sort_name: 'שם (א-ת)',
        sort_prepTime: 'זמן הכנה',
        proc_consistency: 'בודק עקביות...',
        item: 'פריט',
        editMeal: 'ערוך ארוחה',
        itemsLabel: 'פריטים',
        currentWeekBadge: 'השבוע',
          usedTimes: 'נאכל {count} פעמים',
          monthlyRecipeUsage: 'שימוש חודשי במתכונים',
          weeklyRecipeUsage: 'שימוש שבועי במתכונים',
        searchIngredients: 'חפש מרכיבים...',
        syncShoppingList: 'סנכרן לרשימת קניות',
        syncShoppingCompact: 'סנכרן קניות',
        viewUsage: 'צפה בשימוש',
        selectWeeks: 'בחר שבועות',
        sync: 'סנכרן',
        reset: 'איפוס',
        allWeek: 'כל השבוע',
        next3Days: '3 ימים הבאים',
        collapseAll: 'צמצם הכל',
        expandAll: 'הרחב הכל',
        ordinaryItemsRemovedTitle: 'מוצרי מזווה שגרתיים הוסרו',
        ordinaryItemsRemovedMessage: 'מים, שמן, מלח, סוכר ומוצרי מזווה דומים אינם ברשימת התכנון. ניתן להוסיף אותם ישירות לעגלה הפעילה.',
        frozen: 'קפואים',
        bakery: 'מאפים',
        beverages: 'משקאות',
        sortBy: 'מיין לפי',
        list: 'רשימה',
        section: 'מחלקה',
        fruits: 'פירות',
        dairy: 'מוצרי חלב',
        cleaning: 'ניקיון',
        toiletries: 'טואלטיקה',
        canned: 'שימורים',
        pantry: 'מזווה',
        generalfood: 'מצרכים כלליים',
        generalFood: 'מצרכים כלליים',
        timeline: 'ציר זמן',
        allTime: 'הכל',
        last7Days: '7 ימים אחרונים',
        last30Days: '30 ימים אחרונים',
        totalRequests: '{count} בקשות סה"כ',
        showingItems: 'מציג {count} פריטים',
        submittedOn: 'נשלח ב-',
        integrations: 'אינטגרציות',
        mcpServer: 'שרת MCP',
        mcpDescription: 'חבר את Gemini או מודלים חיצוניים דרך פרוטוקול MCP',
        mcpStatus: 'סטטוס',
        mcpUrl: 'כתובת SSE',
        mcpCopyUrl: 'העתק כתובת חיבור',
        mcpConnected: 'מחובר',
        mcpDisconnected: 'לא מחובר',
        toolsApi: 'Tools API (REST)',
        toolsApiDescription: 'נקודות קצה HTTP עם אותן יכולות כמו MCP — חסכוני יותר לשימוש קל',
        toolsApiBaseUrl: 'כתובת בסיס',
        toolsApiCopyUrl: 'העתק כתובת בסיס',
        toolsApiAuthNote: 'שלח את מפתח ה-API כ-Authorization: Bearer <key>',
        apiKey: 'מפתח API',
        generateKey: 'צור מפתח חדש',
        aiEligible: 'זכאי ל-AI',
        aiStatus: 'סטטוס AI',
        aiEnabled: 'AI פעיל',
        aiDisabled: 'AI כבוי',
        aiNotEligible: 'חשבון זה אינו זכאי לתכונות AI',
    },
    es: {
        ...commonEn,
        ingredientNamePlaceholder: 'Nombre del ingrediente',
        newSection: 'Nueva sección',
        addNewSection: 'Agregar nueva sección',
        sectionNamePlaceholder: 'Nombre de la sección',
        newSectionNamePlaceholder: 'Nombre de la nueva sección',
        prepSectionPlaceholder: 'Nombre de la sección',
        ingredient_salt: 'Sal',
        ingredient_sugar: 'Azúcar',
        ingredient_water: 'Agua',
        ingredient_flour: 'Harina',
        ingredient_oil: 'Aceite',
        ingredient_butter: 'Mantequilla',
        ingredient_eggs: 'Huevos',
        'ingredient_baking powder': 'Polvo de hornear',
        ingredient_onion: 'Cebolla',
        ingredient_garlic: 'Ajo',
        butcherItem: 'Carnicería',
        sauce: 'Salsa',
        dough: 'Masa',
        filling: 'Relleno',
        topping: 'Cobertura',
        base: 'Base',
        cream: 'Crema',
        batter: 'Masa',
        'add-ins': 'Adicionales',
        addins: 'Adicionales',
        seasoning: 'Condimentos',
        spices: 'Especias',
        snacks: 'Aperitivos',
        babyProducts: 'Productos para bebé',
        babyproducts: 'Productos para bebé',
        manual: 'Manual',
        meat: 'Carne',
        vegetables: 'Verduras',
        general: 'General',
        other: 'Otro',
        others: 'Otros',
        produce: 'Productos frescos',
        dry_goods: 'Productos secos',
        liquid: 'Líquido',
        main: 'Principal',
        filter: 'Filtrar',
        sort: 'Ordenar',
        moveItem: 'Mover artículo',
        deleteFromList: 'Eliminar de la lista',
        searchResultsCount: 'Encontrado {n} resultados',
        noItemsInSearch: 'No se encontraron artículos',
        createItem: 'Crear nuevo artículo',
        theme: 'Tema',
        themeLight: 'Claro',
        themeDark: 'Oscuro',
        themeSystem: 'Sistema',
        fontSize: 'Tamaño de fuente',
        fontSizeSystem: 'Sistema',
        fontSizeCustom: 'Personalizado',
        fontSmall: 'Pequeño',
        fontDefault: 'Normal',
        fontLarge: 'Grande',
        save: 'Guardar',
        cancel: 'Cancelar',
        ok: 'Aceptar',
        language: 'Idioma',
        weekStart: 'Inicio de semana',
        startMonday: 'Lunes',
        startSunday: 'Domingo',
        exportRecipe: 'Exportar receta',
        copyText: 'Copiar texto',
        textCopied: '¡Texto copiado!',
        unite: 'Unir',
        navigation: 'Navegación',
        quantityToMake: 'Cantidad a preparar',
        servingsPerMeal: 'Porciones por comida',
        totalServings: 'Porciones totales',
        futureMealsNoticeTitle: 'Consejo de preparación por lotes',
        futureMealsPlannedHint: '{recipe} también está planeado para {days}. (Total: {totalServings} porciones en {totalMeals} comidas)',
        scaleToTotalServings: 'Escalar al total ({count} porciones)',
        duration_repeat: 'Duración / Repetir',
        schedule_days_hint: 'Visible por {count} días consecutivos',
        schedule_weeks_hint: 'Se repite cada {day} durante {count} semanas',
        unknownRecipe: 'Receta desconocida',
        editMeal: 'Editar comida',
        frozen: 'Congelados',
        bakery: 'Panadería',
        beverages: 'Bebidas',
        sortBy: 'Ordenar por',
        unit_servings: 'porciones',
        unit_mins: 'min',
        card_servings: 'P',
        card_mins: 'm',
        card_hours: 'h',
        unit_basket: 'canasta',
        unit_heaping_tbsp: 'cucharada colmada',
        unit_tub: 'tarrina',
        unit_handful: 'puñado',
        itemsLabel: 'artículos',
        viewRecipe: 'Ver receta',
        fruits: 'Frutas',
        dairy: 'Lácteos',
        cleaning: 'Limpieza',
        toiletries: 'Artículos de aseo',
        canned: 'Conservas',
        pantry: 'Despensa',
        generalfood: 'Alimentos generales',
        generalFood: 'Alimentos generales',
        list: 'Lista',
        section: 'Sección',
        morning: 'Mañana',
        noon: 'Mediodía',
        evening: 'Noche',
        breakfast: 'Desayuno',
        lunch: 'Almuerzo',
        dinner: 'Cena',
        timeline: 'Cronología',
        allTime: 'Todo el tiempo',
        last7Days: 'Últimos 7 días',
        last30Days: 'Últimos 30 días',
        totalRequests: '{count} Solicitudes Totales',
        showingItems: 'Mostrando {count} elementos',
        submittedOn: 'Enviado el',
        returnToThisWeek: 'Volver a esta semana',
        fastingTimer: 'Temporizador de ayuno',
        fastingStart: 'Iniciar ayuno',
        fastingStop: 'Detener',
        fastingStatistics: 'Estadísticas de ayuno',
        fastingNoHistory: 'Aún no hay historial de ayunos.',
        fastingHoursShort: 'h ',
        fastingMinutesShort: 'm',
        appWarmingUp: 'Calentando el fuego...',
        fastingSecondsShort: 's',
        fastingGoalHours: 'Meta: {hours} horas',
        fastingHoursGoal: '{hours} horas',
        fastingEndsAt: 'Termina a las {time}',
        fastingEndsAtTomorrow: 'Termina mañana a las {time}',
        fastingTimeRemaining: 'Tiempo restante',
        fastingStartFasting: 'Iniciar ayuno',
        fastingStartNow: 'Empezar ahora',
        fastingChangeGoal: 'Cambiar meta',
        fastingEndFast: 'Terminar ayuno',
        fastingEditGoal: 'Editar meta',
        fastingGoalReached: '¡Meta alcanzada!',
        fastingSaveFast: 'Guardar ayuno',
        fastingRemainingLeft: 'Quedan {time}',
        fastingCountdownRemaining: 'Quedan {time}',
        fastingOpenModal: 'Abrir temporizador de ayuno',
        fastingIdleHint: 'Toca iniciar cuando comiences tu ventana de ayuno.',
        intermittentFastingSetting: 'Ayuno intermitente',
        intermittentFastingSettingDesc: 'Muestra el temporizador en la cabecera. Las notificaciones al terminar funcionan con la app instalada.',
        fastingNotificationTitle: '¡Ayuno completado!',
        fastingNotificationBody: 'Tu ayuno de {hours} horas terminó. Ya puedes comer.',
    },
    ar: {
        ...commonEn,
        ingredientNamePlaceholder: 'اسم المكون',
        newSection: 'قسم جديد',
        addNewSection: 'إضافة قسم جديد',
        sectionNamePlaceholder: 'اسم القسم',
        newSectionNamePlaceholder: 'اسم القسم الجديد',
        prepSectionPlaceholder: 'اسم القسم',
        ingredient_salt: 'ملح',
        ingredient_sugar: 'سكر',
        ingredient_water: 'ماء',
        ingredient_flour: 'دقيق',
        ingredient_oil: 'زيت',
        ingredient_butter: 'زبدة',
        ingredient_eggs: 'بيض',
        'ingredient_baking powder': 'بيكنج بودر',
        ingredient_onion: 'بصل',
        ingredient_garlic: 'ثوم',
        butcherItem: 'لحام',
        sauce: 'صلصة',
        dough: 'عجين',
        filling: 'حشوة',
        topping: 'طبقة علوية',
        base: 'قاعدة',
        cream: 'كريمة',
        batter: 'خليط',
        'add-ins': 'إضافات',
        addins: 'إضافات',
        seasoning: 'توابل',
        spices: 'بهارات',
        snacks: 'وجبات خفيفة',
        babyProducts: 'منتجات الأطفال',
        babyproducts: 'منتجات الأطفال',
        manual: 'يدوي',
        meat: 'لحوم',
        vegetables: 'خضروات',
        general: 'عام',
        other: 'أخرى',
        others: 'أخرى',
        produce: 'منتجات طازجة',
        dry_goods: 'بضائع جافة',
        liquid: 'سائل',
        main: 'رئيسي',
        filter: 'تصفية',
        sort: 'فرز',
        moveItem: 'نقل العنصر',
        deleteFromList: 'حذف من القائمة',
        searchResultsCount: 'تم العثور على {n} من النتائج',
        noItemsInSearch: 'لم يتم العثور على عناصر',
        createItem: 'إنشاء عنصر جديد',
        theme: 'المظهر',
        themeLight: 'فاتح',
        themeDark: 'داكن',
        themeSystem: 'النظام',
        fontSize: 'حجم الخط',
        fontSizeSystem: 'النظام',
        fontSizeCustom: 'مخصص',
        fontSmall: 'صغير',
        fontDefault: 'افتراضي',
        fontLarge: 'كبير',
        save: 'حفظ',
        cancel: 'إلغاء',
        ok: 'موافق',
        language: 'اللغة',
        weekStart: 'بداية الأسبوع',
        startMonday: 'الاثنين',
        startSunday: 'الأحد',
        exportRecipe: 'تصدير الوصفة',
        copyText: 'نسخ النص',
        textCopied: 'تم نسخ النص!',
        unite: 'توحيد',
        navigation: 'التنقل',
        quantityToMake: 'الكمية للتحضير',
        servingsPerMeal: 'حصص لكل وجبة',
        totalServings: 'إجمالي الحصص',
        futureMealsNoticeTitle: 'تلميح تحضير الدفعات',
        futureMealsPlannedHint: 'تم التخطيط لـ {recipe} أيضًا في {days}. (الإجمالي: {totalServings} حصة في {totalMeals} وجبات)',
        scaleToTotalServings: 'تغيير الحجم إلى الإجمالي ({count} حصص)',
        duration_repeat: 'المدة / التكرار',
        schedule_days_hint: 'مرئي لمدة {count} أيام متتالية',
        schedule_weeks_hint: 'يتكرر كل {day} لمدة {count} أسابيع',
        unknownRecipe: 'وصفة غير معروفة',
        editMeal: 'تعديل الوجبة',
        frozen: 'مجمدات',
        bakery: 'مخبوزات',
        beverages: 'مشروبات',
        sortBy: 'ترتيب حسب',
        unit_servings: 'حصص',
        unit_mins: 'دقيقة',
        card_servings: 'ح',
        card_mins: 'د',
        card_hours: 'س',
        unit_basket: 'سلة',
        unit_heaping_tbsp: 'ملعقة كبيرة ممتلئة',
        unit_tub: 'علبة',
        unit_handful: 'حفنة',
        itemsLabel: 'عناصر',
        viewRecipe: 'عرض الوصفة',
        fruits: 'فواكه',
        dairy: 'منتجات الألبان',
        cleaning: 'تنظيف',
        toiletries: 'مستلزمات الحمام',
        canned: 'معلبات',
        pantry: 'خزانة المؤن',
        generalfood: 'طعام عام',
        generalFood: 'طعام عام',
        list: 'قائمة',
        section: 'قسم',
        morning: 'صباح',
        noon: 'ظهر',
        evening: 'مساء',
        breakfast: 'فطور',
        lunch: 'غداء',
        dinner: 'عشاء',
        timeline: 'الجدول الزمني',
        allTime: 'كل الوقت',
        last7Days: 'آخر 7 أيام',
        last30Days: 'آخر 30 يومًا',
        totalRequests: '{count} إجمالي الطلبات',
        showingItems: 'عرض {count} عنصر',
        submittedOn: 'قدمت في',
        returnToThisWeek: 'العودة إلى هذا الأسبوع',
        fastingTimer: 'مؤقت الصيام',
        fastingStart: 'بدء الصيام',
        fastingStop: 'إيقاف',
        fastingStatistics: 'إحصائيات الصيام',
        fastingNoHistory: 'لا يوجد سجل صيام بعد.',
        fastingHoursShort: ' س ',
        fastingMinutesShort: ' د',
        appWarmingUp: 'يُحمَّى الموقد...',
        fastingSecondsShort: ' ث',
        fastingGoalHours: 'الهدف: {hours} ساعات',
        fastingHoursGoal: '{hours} ساعات',
        fastingEndsAt: 'ينتهي في {time}',
        fastingEndsAtTomorrow: 'ينتهي غداً في {time}',
        fastingTimeRemaining: 'الوقت المتبقي',
        fastingStartFasting: 'بدء الصيام',
        fastingStartNow: 'ابدأ الآن',
        fastingChangeGoal: 'تغيير الهدف',
        fastingEndFast: 'إنهاء الصيام',
        fastingEditGoal: 'تعديل الهدف',
        fastingGoalReached: 'تم تحقيق الهدف!',
        fastingSaveFast: 'حفظ الصيام',
        fastingRemainingLeft: 'متبقٍ {time}',
        fastingCountdownRemaining: 'متبقٍ {time}',
        fastingOpenModal: 'فتح مؤقت الصيام',
        fastingIdleHint: 'اضغط بدء عندما تبدأ نافذة الصيام.',
        intermittentFastingSetting: 'الصيام المتقطع',
        intermittentFastingSettingDesc: 'اعرض مؤقت الصيام في الشريط العلوي. الإشعارات عند الانتهاء تعمل عند تثبيت التطبيق.',
        fastingNotificationTitle: 'اكتمل الصيام!',
        fastingNotificationBody: 'انتهى صيامك لمدة {hours} ساعات. يمكنك الأكل الآن.',
    },
    de: {
        ...commonEn,
        ingredientNamePlaceholder: 'Name der Zutat',
        newSection: 'Neuer Bereich',
        addNewSection: 'Neuen Bereich hinzufügen',
        sectionNamePlaceholder: 'Bereichsname',
        newSectionNamePlaceholder: 'Neuer Bereichsname',
        prepSectionPlaceholder: 'Bereichsname',
        ingredient_salt: 'Salz',
        ingredient_sugar: 'Zucker',
        ingredient_water: 'Wasser',
        ingredient_flour: 'Mehl',
        ingredient_oil: 'Öl',
        ingredient_butter: 'Butter',
        ingredient_eggs: 'Eier',
        'ingredient_baking powder': 'Backpulver',
        ingredient_onion: 'Zwiebel',
        ingredient_garlic: 'Knoblauch',
        butcherItem: 'Metzgerei',
        sauce: 'Soße',
        dough: 'Teig',
        filling: 'Füllung',
        topping: 'Belag',
        base: 'Basis',
        cream: 'Sahne',
        batter: 'Teig',
        'add-ins': 'Zutaten',
        addins: 'Zutaten',
        seasoning: 'Würze',
        spices: 'Gewürze',
        snacks: 'Snacks',
        babyProducts: 'Babyprodukte',
        babyproducts: 'Babyprodukte',
        manual: 'Manuell',
        meat: 'Fleisch',
        vegetables: 'Gemüse',
        general: 'Allgemein',
        other: 'Sonstiges',
        others: 'Sonstiges',
        produce: 'Frischwaren',
        dry_goods: 'Trockenwaren',
        liquid: 'Flüssigkeit',
        main: 'Hauptgericht',
        filter: 'Filtern',
        sort: 'Sortieren',
        moveItem: 'Artikel verschieben',
        deleteFromList: 'Aus Liste löschen',
        searchResultsCount: '{n} Ergebnisse gefunden',
        noItemsInSearch: 'Keine Artikel gefunden',
        createItem: 'Neuen Artikel erstellen',
        theme: 'Design',
        themeLight: 'Hell',
        themeDark: 'Dunkel',
        themeSystem: 'System',
        fontSize: 'Schriftgröße',
        fontSizeSystem: 'System',
        fontSizeCustom: 'Benutzerdefiniert',
        fontSmall: 'Klein',
        fontDefault: 'Standard',
        fontLarge: 'Groß',
        save: 'Speichern',
        cancel: 'Abbrechen',
        ok: 'OK',
        language: 'Sprache',
        weekStart: 'Wochenbeginn',
        startMonday: 'Montag',
        startSunday: 'Sonntag',
        exportRecipe: 'Rezept exportieren',
        copyText: 'Text kopieren',
        textCopied: 'Text kopiert!',
        unite: 'Vereinen',
        navigation: 'Navigation',
        quantityToMake: 'Zubereitungsmenge',
        servingsPerMeal: 'Portionen pro Mahlzeit',
        totalServings: 'Gesamtportionen',
        futureMealsNoticeTitle: 'Vorbereitungstipp',
        futureMealsPlannedHint: '{recipe} ist auch für {days} geplant. (Gesamt: {totalServings} Portionen in {totalMeals} Mahlzeiten)',
        scaleToTotalServings: 'Auf Gesamtmenge skalieren ({count} Portionen)',
        duration_repeat: 'Dauer / Wiederholung',
        schedule_days_hint: 'Sichtbar für {count} aufeinanderfolgende Tage',
        schedule_weeks_hint: 'Wiederholt sich jeden {day} für {count} Wochen',
        unknownRecipe: 'Unbekanntes Rezept',
        editMeal: 'Mahlzeit bearbeiten',
        frozen: 'Tiefkühlkost',
        bakery: 'Bäckerei',
        beverages: 'Getränke',
        sortBy: 'Sortieren nach',
        unit_servings: 'Portionen',
        unit_mins: 'Min',
        card_servings: 'P',
        card_mins: 'm',
        card_hours: 'h',
        unit_basket: 'Korb',
        unit_heaping_tbsp: 'gehäufter EL',
        unit_tub: 'Becher',
        unit_handful: 'Handvoll',
        itemsLabel: 'Artikel',
        viewRecipe: 'Rezept ansehen',
        fruits: 'Obst',
        dairy: 'Milchprodukte',
        cleaning: 'Reinigung',
        toiletries: 'Pflegeprodukte',
        canned: 'Konserven',
        pantry: 'Vorratskammer',
        generalfood: 'Allgemeine Lebensmittel',
        generalFood: 'Allgemeine Lebensmittel',
        list: 'Liste',
        section: 'Bereich',
        morning: 'Morgen',
        noon: 'Mittag',
        evening: 'Abend',
        breakfast: 'Frühstück',
        lunch: 'Mittagessen',
        dinner: 'Abendessen',
        timeline: 'Zeitleiste',
        allTime: 'Alle Zeit',
        last7Days: 'Letzte 7 Tage',
        last30Days: 'Letzte 30 Tage',
        totalRequests: '{count} Anfragen insgesamt',
        showingItems: 'Zeige {count} Elemente',
        submittedOn: 'Eingereicht am',
        returnToThisWeek: 'Zurück zu dieser Woche',
        fastingTimer: 'Fasten-Timer',
        fastingStart: 'Fasten starten',
        fastingStop: 'Beenden',
        fastingStatistics: 'Fastenstatistik',
        fastingNoHistory: 'Noch kein Fastenverlauf.',
        fastingHoursShort: ' Std ',
        fastingMinutesShort: ' Min',
        appWarmingUp: 'Feuer wird angeheizt...',
        fastingSecondsShort: ' Sek',
        fastingGoalHours: 'Ziel: {hours} Stunden',
        fastingHoursGoal: '{hours} Stunden',
        fastingEndsAt: 'Endet um {time}',
        fastingEndsAtTomorrow: 'Endet morgen um {time}',
        fastingTimeRemaining: 'Verbleibende Zeit',
        fastingStartFasting: 'Fasten starten',
        fastingStartNow: 'Jetzt starten',
        fastingChangeGoal: 'Ziel ändern',
        fastingEndFast: 'Fasten beenden',
        fastingEditGoal: 'Ziel bearbeiten',
        fastingGoalReached: 'Ziel erreicht!',
        fastingSaveFast: 'Fasten speichern',
        fastingRemainingLeft: 'Noch {time}',
        fastingCountdownRemaining: 'Noch {time}',
        fastingOpenModal: 'Fasten-Timer öffnen',
        fastingIdleHint: 'Tippe auf Starten, wenn dein Fastenfenster beginnt.',
        intermittentFastingSetting: 'Intermittierendes Fasten',
        intermittentFastingSettingDesc: 'Zeigt den Fasten-Timer in der Kopfzeile. Benachrichtigungen am Ende funktionieren nur als installierte App.',
        fastingNotificationTitle: 'Fasten beendet!',
        fastingNotificationBody: 'Dein {hours}-Stunden-Fasten ist vorbei. Du kannst jetzt essen.',
    },
    fr: {
        ...commonEn,
        ingredientNamePlaceholder: "Nom de l'ingrédient",
        newSection: 'Nouvelle section',
        addNewSection: 'Ajouter une nouvelle section',
        sectionNamePlaceholder: 'Nom de la section',
        newSectionNamePlaceholder: 'Nom de la nouvelle section',
        prepSectionPlaceholder: 'Nom de la section',
        ingredient_salt: 'Sel',
        ingredient_sugar: 'Sucre',
        ingredient_water: 'Eau',
        ingredient_flour: 'Farine',
        ingredient_oil: 'Huile',
        ingredient_butter: 'Beurre',
        ingredient_eggs: 'Œufs',
        'ingredient_baking powder': 'Levure chimique',
        ingredient_onion: 'Oignon',
        ingredient_garlic: 'Ail',
        butcherItem: 'Boucherie',
        sauce: 'Sauce',
        dough: 'Pâte',
        filling: 'Garniture',
        topping: 'Nappage',
        base: 'Base',
        cream: 'Crème',
        batter: 'Pâte',
        'add-ins': 'Ajouts',
        addins: 'Ajouts',
        seasoning: 'Assaisonnement',
        spices: 'Épices',
        snacks: 'Collations',
        babyProducts: 'Produits pour bébé',
        babyproducts: 'Produits pour bébé',
        manual: 'Manuel',
        meat: 'Viande',
        vegetables: 'Légumes',
        general: 'Général',
        other: 'Autre',
        others: 'Autres',
        produce: 'Produits frais',
        dry_goods: 'Produits secs',
        liquid: 'Liquide',
        main: 'Principal',
        filter: 'Filtrer',
        sort: 'Trier',
        moveItem: 'Déplacer l\'article',
        deleteFromList: 'Supprimer de la liste',
        searchResultsCount: '{n} résultats trouvés',
        noItemsInSearch: 'Aucun article trouvé',
        createItem: 'Créer un nouvel article',
        theme: 'Thème',
        themeLight: 'Clair',
        themeDark: 'Sombre',
        themeSystem: 'Système',
        fontSize: 'Taille de la police',
        fontSizeSystem: 'Système',
        fontSizeCustom: 'Personnalisé',
        fontSmall: 'Petit',
        fontDefault: 'Par défaut',
        fontLarge: 'Grand',
        save: 'Enregistrer',
        cancel: 'Annuler',
        ok: 'OK',
        language: 'Langue',
        weekStart: 'Début de semaine',
        startMonday: 'Lundi',
        startSunday: 'Dimanche',
        exportRecipe: 'Exporter la recette',
        copyText: 'Copier le texte',
        textCopied: 'Texte copié !',
        unite: 'Unir',
        navigation: 'Navigation',
        quantityToMake: 'Quantité à préparer',
        servingsPerMeal: 'Portions par repas',
        totalServings: 'Portions totales',
        futureMealsNoticeTitle: 'Astuce préparation',
        futureMealsPlannedHint: '{recipe} est aussi prévu pour {days}. (Total: {totalServings} portions sur {totalMeals} repas)',
        scaleToTotalServings: 'Adapter au total ({count} portions)',
        duration_repeat: 'Durée / Répétition',
        schedule_days_hint: 'Visible pendant {count} jours consécutifs',
        schedule_weeks_hint: 'Répète chaque {day} pendant {count} semaines',
        unknownRecipe: 'Recette inconnue',
        editMeal: 'Modifier le repas',
        frozen: 'Surgelés',
        bakery: 'Boulangerie',
        beverages: 'Boissons',
        sortBy: 'Trier par',
        unit_servings: 'portions',
        unit_mins: 'min',
        card_servings: 'P',
        card_mins: 'm',
        card_hours: 'h',
        unit_basket: 'panier',
        unit_heaping_tbsp: 'c. à s. bombée',
        unit_tub: 'pot',
        unit_handful: 'poignée',
        itemsLabel: 'articles',
        viewRecipe: 'Voir la recette',
        fruits: 'Fruits',
        dairy: 'Produits laitiers',
        cleaning: 'Nettoyage',
        toiletries: 'Articles de toilette',
        canned: 'Conserves',
        pantry: 'Garde-manger',
        generalfood: 'Alimentation générale',
        generalFood: 'Alimentation générale',
        list: 'Liste',
        section: 'Section',
        morning: 'Matin',
        noon: 'Midi',
        evening: 'Soir',
        breakfast: 'Petit-déjeuner',
        lunch: 'Déjeuner',
        dinner: 'Dîner',
        timeline: 'Chronologie',
        allTime: 'Tout le temps',
        last7Days: '7 derniers jours',
        last30Days: '30 derniers jours',
        totalRequests: '{count} demandes au total',
        showingItems: 'Affichage de {count} éléments',
        submittedOn: 'Soumis le',
        returnToThisWeek: 'Retour à cette semaine',
        fastingTimer: 'Minuteur de jeûne',
        fastingStart: 'Commencer le jeûne',
        fastingStop: 'Arrêter',
        fastingStatistics: 'Statistiques de jeûne',
        fastingNoHistory: 'Aucun historique de jeûne pour le moment.',
        fastingHoursShort: ' h ',
        fastingMinutesShort: ' min',
        appWarmingUp: 'On chauffe le feu...',
        fastingSecondsShort: ' s',
        fastingGoalHours: 'Objectif : {hours} heures',
        fastingHoursGoal: '{hours} heures',
        fastingEndsAt: 'Se termine à {time}',
        fastingEndsAtTomorrow: 'Se termine demain à {time}',
        fastingTimeRemaining: 'Temps restant',
        fastingStartFasting: 'Commencer le jeûne',
        fastingStartNow: 'Commencer maintenant',
        fastingChangeGoal: 'Changer l\'objectif',
        fastingEndFast: 'Terminer le jeûne',
        fastingEditGoal: 'Modifier l\'objectif',
        fastingGoalReached: 'Objectif atteint !',
        fastingSaveFast: 'Enregistrer le jeûne',
        fastingRemainingLeft: 'Il reste {time}',
        fastingCountdownRemaining: 'Il reste {time}',
        fastingOpenModal: 'Ouvrir le minuteur de jeûne',
        fastingIdleHint: 'Appuyez sur démarrer au début de votre fenêtre de jeûne.',
        intermittentFastingSetting: 'Jeûne intermittent',
        intermittentFastingSettingDesc: 'Affiche le minuteur dans l’en-tête. Les notifications de fin fonctionnent lorsque l’app est installée.',
        fastingNotificationTitle: 'Jeûne terminé !',
        fastingNotificationBody: 'Votre jeûne de {hours} heures est terminé. Vous pouvez manger.',
    }
};

export const getTranslation = (lang: Language | undefined, key: string): string => {
    const language = lang || 'en';
    const dict = translations[language] || translations['en'];
    return dict[key] || translations['en'][key] || key;
};

export const isRTL = (lang: Language | undefined): boolean => {
    return lang === 'he' || lang === 'ar';
};
